import React from 'react'
import './iconStyle.css'
import { Link } from 'react-router-dom';
import CodeBox from '../../CodeBox';

const BootstrapIcon = () => {

	const bootstrapCode = `<i className="bi-alarm"></i>`;

	return (
		<div className="row">
			<div className="col-md-12">
				<div className='card h-100'>
					<div className="rounded-4 mb-3 mb-sm-0 bg-white">
						<div className="card-body">
							<div className="px-xl-5 px-lg-4 px-3 py-3 page-body bg-card">
								<h4 className="mb-4">Bootstrap icon</h4>
								<p className="lead">Free, high quality, open source icon library with over 1,600 icons. Include them anyway you like—SVGs, SVG sprite, or web fonts. Use them with or without <Link to="https://getbootstrap.com/">Bootstrap</Link> in any project.</p>
								<div className="row g-xl-5 g-4">
									<div className="col-12">
										<div className="rounded-4" data-lang="html">
											{/* // x---------------------------------x CodeBox Component x---------------------------------x */}
											<CodeBox code={bootstrapCode} auto={true} />
										</div>
									</div>
								</div>

								{/* // x---------------------------------x All Icons Section x---------------------------------x */}
								<div className="row g-3 row-cols-lg-3 row-cols-md-3 row-cols-sm-2 row-cols-1 icons-list m-0">
									<div className="col icon">
										<i className="bi bi-alarm-fill"></i>
										<div className="label">alarm-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-alarm"></i>
										<div className="label">alarm</div>
									</div>
									<div className="col icon">
										<i className="bi bi-align-bottom"></i>
										<div className="label">align-bottom</div>
									</div>
									<div className="col icon">
										<i className="bi bi-align-center"></i>
										<div className="label">align-center</div>
									</div>
									<div className="col icon">
										<i className="bi bi-align-end"></i>
										<div className="label">align-end</div>
									</div>
									<div className="col icon">
										<i className="bi bi-align-middle"></i>
										<div className="label">align-middle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-align-start"></i>
										<div className="label">align-start</div>
									</div>
									<div className="col icon">
										<i className="bi bi-align-top"></i>
										<div className="label">align-top</div>
									</div>
									<div className="col icon">
										<i className="bi bi-alt"></i>
										<div className="label">alt</div>
									</div>
									<div className="col icon">
										<i className="bi bi-app-indicator"></i>
										<div className="label">app-indicator</div>
									</div>
									<div className="col icon">
										<i className="bi bi-app"></i>
										<div className="label">app</div>
									</div>
									<div className="col icon">
										<i className="bi bi-archive-fill"></i>
										<div className="label">archive-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-archive"></i>
										<div className="label">archive</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-90deg-down"></i>
										<div className="label">arrow-90deg-down</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-90deg-left"></i>
										<div className="label">arrow-90deg-left</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-90deg-right"></i>
										<div className="label">arrow-90deg-right</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-90deg-up"></i>
										<div className="label">arrow-90deg-up</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-bar-down"></i>
										<div className="label">arrow-bar-down</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-bar-left"></i>
										<div className="label">arrow-bar-left</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-bar-right"></i>
										<div className="label">arrow-bar-right</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-bar-up"></i>
										<div className="label">arrow-bar-up</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-clockwise"></i>
										<div className="label">arrow-clockwise</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-counterclockwise"></i>
										<div className="label">arrow-counterclockwise</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-down-circle-fill"></i>
										<div className="label">arrow-down-circle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-down-circle"></i>
										<div className="label">arrow-down-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-down-left-circle-fill"></i>
										<div className="label">arrow-down-left-circle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-down-left-circle"></i>
										<div className="label">arrow-down-left-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-down-left-square-fill"></i>
										<div className="label">arrow-down-left-square-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-down-left-square"></i>
										<div className="label">arrow-down-left-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-down-left"></i>
										<div className="label">arrow-down-left</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-down-right-circle-fill"></i>
										<div className="label">arrow-down-right-circle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-down-right-circle"></i>
										<div className="label">arrow-down-right-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-down-right-square-fill"></i>
										<div className="label">arrow-down-right-square-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-down-right-square"></i>
										<div className="label">arrow-down-right-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-down-right"></i>
										<div className="label">arrow-down-right</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-down-short"></i>
										<div className="label">arrow-down-short</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-down-square-fill"></i>
										<div className="label">arrow-down-square-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-down-square"></i>
										<div className="label">arrow-down-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-down-up"></i>
										<div className="label">arrow-down-up</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-down"></i>
										<div className="label">arrow-down</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-left-circle-fill"></i>
										<div className="label">arrow-left-circle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-left-circle"></i>
										<div className="label">arrow-left-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-left-right"></i>
										<div className="label">arrow-left-right</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-left-short"></i>
										<div className="label">arrow-left-short</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-left-square-fill"></i>
										<div className="label">arrow-left-square-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-left-square"></i>
										<div className="label">arrow-left-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-left"></i>
										<div className="label">arrow-left</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-repeat"></i>
										<div className="label">arrow-repeat</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-return-left"></i>
										<div className="label">arrow-return-left</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-return-right"></i>
										<div className="label">arrow-return-right</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-right-circle-fill"></i>
										<div className="label">arrow-right-circle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-right-circle"></i>
										<div className="label">arrow-right-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-right-short"></i>
										<div className="label">arrow-right-short</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-right-square-fill"></i>
										<div className="label">arrow-right-square-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-right-square"></i>
										<div className="label">arrow-right-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-right"></i>
										<div className="label">arrow-right</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-up-circle-fill"></i>
										<div className="label">arrow-up-circle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-up-circle"></i>
										<div className="label">arrow-up-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-up-left-circle-fill"></i>
										<div className="label">arrow-up-left-circle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-up-left-circle"></i>
										<div className="label">arrow-up-left-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-up-left-square-fill"></i>
										<div className="label">arrow-up-left-square-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-up-left-square"></i>
										<div className="label">arrow-up-left-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-up-left"></i>
										<div className="label">arrow-up-left</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-up-right-circle-fill"></i>
										<div className="label">arrow-up-right-circle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-up-right-circle"></i>
										<div className="label">arrow-up-right-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-up-right-square-fill"></i>
										<div className="label">arrow-up-right-square-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-up-right-square"></i>
										<div className="label">arrow-up-right-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-up-right"></i>
										<div className="label">arrow-up-right</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-up-short"></i>
										<div className="label">arrow-up-short</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-up-square-fill"></i>
										<div className="label">arrow-up-square-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-up-square"></i>
										<div className="label">arrow-up-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrow-up"></i>
										<div className="label">arrow-up</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrows-angle-contract"></i>
										<div className="label">arrows-angle-contract</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrows-angle-expand"></i>
										<div className="label">arrows-angle-expand</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrows-collapse"></i>
										<div className="label">arrows-collapse</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrows-expand"></i>
										<div className="label">arrows-expand</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrows-fullscreen"></i>
										<div className="label">arrows-fullscreen</div>
									</div>
									<div className="col icon">
										<i className="bi bi-arrows-move"></i>
										<div className="label">arrows-move</div>
									</div>
									<div className="col icon">
										<i className="bi bi-aspect-ratio-fill"></i>
										<div className="label">aspect-ratio-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-aspect-ratio"></i>
										<div className="label">aspect-ratio</div>
									</div>
									<div className="col icon">
										<i className="bi bi-asterisk"></i>
										<div className="label">asterisk</div>
									</div>
									<div className="col icon">
										<i className="bi bi-at"></i>
										<div className="label">at</div>
									</div>
									<div className="col icon">
										<i className="bi bi-award-fill"></i>
										<div className="label">award-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-award"></i>
										<div className="label">award</div>
									</div>
									<div className="col icon">
										<i className="bi bi-back"></i>
										<div className="label">back</div>
									</div>
									<div className="col icon">
										<i className="bi bi-backspace-fill"></i>
										<div className="label">backspace-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-backspace-reverse-fill"></i>
										<div className="label">backspace-reverse-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-backspace-reverse"></i>
										<div className="label">backspace-reverse</div>
									</div>
									<div className="col icon">
										<i className="bi bi-backspace"></i>
										<div className="label">backspace</div>
									</div>
									<div className="col icon">
										<i className="bi bi-badge-3d-fill"></i>
										<div className="label">badge-3d-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-badge-3d"></i>
										<div className="label">badge-3d</div>
									</div>
									<div className="col icon">
										<i className="bi bi-badge-4k-fill"></i>
										<div className="label">badge-4k-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-badge-4k"></i>
										<div className="label">badge-4k</div>
									</div>
									<div className="col icon">
										<i className="bi bi-badge-8k-fill"></i>
										<div className="label">badge-8k-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-badge-8k"></i>
										<div className="label">badge-8k</div>
									</div>
									<div className="col icon">
										<i className="bi bi-badge-ad-fill"></i>
										<div className="label">badge-ad-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-badge-ad"></i>
										<div className="label">badge-ad</div>
									</div>
									<div className="col icon">
										<i className="bi bi-badge-ar-fill"></i>
										<div className="label">badge-ar-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-badge-ar"></i>
										<div className="label">badge-ar</div>
									</div>
									<div className="col icon">
										<i className="bi bi-badge-cc-fill"></i>
										<div className="label">badge-cc-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-badge-cc"></i>
										<div className="label">badge-cc</div>
									</div>
									<div className="col icon">
										<i className="bi bi-badge-hd-fill"></i>
										<div className="label">badge-hd-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-badge-hd"></i>
										<div className="label">badge-hd</div>
									</div>
									<div className="col icon">
										<i className="bi bi-badge-tm-fill"></i>
										<div className="label">badge-tm-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-badge-tm"></i>
										<div className="label">badge-tm</div>
									</div>
									<div className="col icon">
										<i className="bi bi-badge-vo-fill"></i>
										<div className="label">badge-vo-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-badge-vo"></i>
										<div className="label">badge-vo</div>
									</div>
									<div className="col icon">
										<i className="bi bi-badge-vr-fill"></i>
										<div className="label">badge-vr-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-badge-vr"></i>
										<div className="label">badge-vr</div>
									</div>
									<div className="col icon">
										<i className="bi bi-badge-wc-fill"></i>
										<div className="label">badge-wc-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-badge-wc"></i>
										<div className="label">badge-wc</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bag-check-fill"></i>
										<div className="label">bag-check-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bag-check"></i>
										<div className="label">bag-check</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bag-dash-fill"></i>
										<div className="label">bag-dash-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bag-dash"></i>
										<div className="label">bag-dash</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bag-fill"></i>
										<div className="label">bag-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bag-plus-fill"></i>
										<div className="label">bag-plus-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bag-plus"></i>
										<div className="label">bag-plus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bag-x-fill"></i>
										<div className="label">bag-x-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bag-x"></i>
										<div className="label">bag-x</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bag"></i>
										<div className="label">bag</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bank"></i>
										<div className="label">bank</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bank2"></i>
										<div className="label">bank2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bar-chart-fill"></i>
										<div className="label">bar-chart-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bar-chart-line-fill"></i>
										<div className="label">bar-chart-line-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bar-chart-line"></i>
										<div className="label">bar-chart-line</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bar-chart-steps"></i>
										<div className="label">bar-chart-steps</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bar-chart"></i>
										<div className="label">bar-chart</div>
									</div>
									<div className="col icon">
										<i className="bi bi-basket-fill"></i>
										<div className="label">basket-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-basket"></i>
										<div className="label">basket</div>
									</div>
									<div className="col icon">
										<i className="bi bi-basket2-fill"></i>
										<div className="label">basket2-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-basket2"></i>
										<div className="label">basket2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-basket3-fill"></i>
										<div className="label">basket3-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-basket3"></i>
										<div className="label">basket3</div>
									</div>
									<div className="col icon">
										<i className="bi bi-battery-charging"></i>
										<div className="label">battery-charging</div>
									</div>
									<div className="col icon">
										<i className="bi bi-battery-full"></i>
										<div className="label">battery-full</div>
									</div>
									<div className="col icon">
										<i className="bi bi-battery-half"></i>
										<div className="label">battery-half</div>
									</div>
									<div className="col icon">
										<i className="bi bi-battery"></i>
										<div className="label">battery</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bell-fill"></i>
										<div className="label">bell-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bell-slash-fill"></i>
										<div className="label">bell-slash-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bell-slash"></i>
										<div className="label">bell-slash</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bell"></i>
										<div className="label">bell</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bezier"></i>
										<div className="label">bezier</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bezier2"></i>
										<div className="label">bezier2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bicycle"></i>
										<div className="label">bicycle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-binoculars-fill"></i>
										<div className="label">binoculars-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-binoculars"></i>
										<div className="label">binoculars</div>
									</div>
									<div className="col icon">
										<i className="bi bi-blockquote-left"></i>
										<div className="label">blockquote-left</div>
									</div>
									<div className="col icon">
										<i className="bi bi-blockquote-right"></i>
										<div className="label">blockquote-right</div>
									</div>
									<div className="col icon">
										<i className="bi bi-book-fill"></i>
										<div className="label">book-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-book-half"></i>
										<div className="label">book-half</div>
									</div>
									<div className="col icon">
										<i className="bi bi-book"></i>
										<div className="label">book</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bookmark-check-fill"></i>
										<div className="label">bookmark-check-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bookmark-check"></i>
										<div className="label">bookmark-check</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bookmark-dash-fill"></i>
										<div className="label">bookmark-dash-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bookmark-dash"></i>
										<div className="label">bookmark-dash</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bookmark-fill"></i>
										<div className="label">bookmark-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bookmark-heart-fill"></i>
										<div className="label">bookmark-heart-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bookmark-heart"></i>
										<div className="label">bookmark-heart</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bookmark-plus-fill"></i>
										<div className="label">bookmark-plus-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bookmark-plus"></i>
										<div className="label">bookmark-plus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bookmark-star-fill"></i>
										<div className="label">bookmark-star-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bookmark-star"></i>
										<div className="label">bookmark-star</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bookmark-x-fill"></i>
										<div className="label">bookmark-x-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bookmark-x"></i>
										<div className="label">bookmark-x</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bookmark"></i>
										<div className="label">bookmark</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bookmarks-fill"></i>
										<div className="label">bookmarks-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bookmarks"></i>
										<div className="label">bookmarks</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bookshelf"></i>
										<div className="label">bookshelf</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bootstrap-fill"></i>
										<div className="label">bootstrap-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bootstrap-reboot"></i>
										<div className="label">bootstrap-reboot</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bootstrap"></i>
										<div className="label">bootstrap</div>
									</div>
									<div className="col icon">
										<i className="bi bi-border-all"></i>
										<div className="label">border-all</div>
									</div>
									<div className="col icon">
										<i className="bi bi-border-bottom"></i>
										<div className="label">border-bottom</div>
									</div>
									<div className="col icon">
										<i className="bi bi-border-center"></i>
										<div className="label">border-center</div>
									</div>
									<div className="col icon">
										<i className="bi bi-border-inner"></i>
										<div className="label">border-inner</div>
									</div>
									<div className="col icon">
										<i className="bi bi-border-left"></i>
										<div className="label">border-left</div>
									</div>
									<div className="col icon">
										<i className="bi bi-border-middle"></i>
										<div className="label">border-middle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-border-outer"></i>
										<div className="label">border-outer</div>
									</div>
									<div className="col icon">
										<i className="bi bi-border-right"></i>
										<div className="label">border-right</div>
									</div>
									<div className="col icon">
										<i className="bi bi-border-style"></i>
										<div className="label">border-style</div>
									</div>
									<div className="col icon">
										<i className="bi bi-border-top"></i>
										<div className="label">border-top</div>
									</div>
									<div className="col icon">
										<i className="bi bi-border-width"></i>
										<div className="label">border-width</div>
									</div>
									<div className="col icon">
										<i className="bi bi-border"></i>
										<div className="label">border</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bounding-box-circles"></i>
										<div className="label">bounding-box-circles</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bounding-box"></i>
										<div className="label">bounding-box</div>
									</div>
									<div className="col icon">
										<i className="bi bi-box-arrow-down-left"></i>
										<div className="label">box-arrow-down-left</div>
									</div>
									<div className="col icon">
										<i className="bi bi-box-arrow-down-right"></i>
										<div className="label">box-arrow-down-right</div>
									</div>
									<div className="col icon">
										<i className="bi bi-box-arrow-down"></i>
										<div className="label">box-arrow-down</div>
									</div>
									<div className="col icon">
										<i className="bi bi-box-arrow-in-down-left"></i>
										<div className="label">box-arrow-in-down-left</div>
									</div>
									<div className="col icon">
										<i className="bi bi-box-arrow-in-down-right"></i>
										<div className="label">box-arrow-in-down-right</div>
									</div>
									<div className="col icon">
										<i className="bi bi-box-arrow-in-down"></i>
										<div className="label">box-arrow-in-down</div>
									</div>
									<div className="col icon">
										<i className="bi bi-box-arrow-in-left"></i>
										<div className="label">box-arrow-in-left</div>
									</div>
									<div className="col icon">
										<i className="bi bi-box-arrow-in-right"></i>
										<div className="label">box-arrow-in-right</div>
									</div>
									<div className="col icon">
										<i className="bi bi-box-arrow-in-up-left"></i>
										<div className="label">box-arrow-in-up-left</div>
									</div>
									<div className="col icon">
										<i className="bi bi-box-arrow-in-up-right"></i>
										<div className="label">box-arrow-in-up-right</div>
									</div>
									<div className="col icon">
										<i className="bi bi-box-arrow-in-up"></i>
										<div className="label">box-arrow-in-up</div>
									</div>
									<div className="col icon">
										<i className="bi bi-box-arrow-left"></i>
										<div className="label">box-arrow-left</div>
									</div>
									<div className="col icon">
										<i className="bi bi-box-arrow-right"></i>
										<div className="label">box-arrow-right</div>
									</div>
									<div className="col icon">
										<i className="bi bi-box-arrow-up-left"></i>
										<div className="label">box-arrow-up-left</div>
									</div>
									<div className="col icon">
										<i className="bi bi-box-arrow-up-right"></i>
										<div className="label">box-arrow-up-right</div>
									</div>
									<div className="col icon">
										<i className="bi bi-box-arrow-up"></i>
										<div className="label">box-arrow-up</div>
									</div>
									<div className="col icon">
										<i className="bi bi-box-seam"></i>
										<div className="label">box-seam</div>
									</div>
									<div className="col icon">
										<i className="bi bi-box"></i>
										<div className="label">box</div>
									</div>
									<div className="col icon">
										<i className="bi bi-braces"></i>
										<div className="label">braces</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bricks"></i>
										<div className="label">bricks</div>
									</div>
									<div className="col icon">
										<i className="bi bi-briefcase-fill"></i>
										<div className="label">briefcase-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-briefcase"></i>
										<div className="label">briefcase</div>
									</div>
									<div className="col icon">
										<i className="bi bi-brightness-alt-high-fill"></i>
										<div className="label">brightness-alt-high-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-brightness-alt-high"></i>
										<div className="label">brightness-alt-high</div>
									</div>
									<div className="col icon">
										<i className="bi bi-brightness-alt-low-fill"></i>
										<div className="label">brightness-alt-low-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-brightness-alt-low"></i>
										<div className="label">brightness-alt-low</div>
									</div>
									<div className="col icon">
										<i className="bi bi-brightness-high-fill"></i>
										<div className="label">brightness-high-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-brightness-high"></i>
										<div className="label">brightness-high</div>
									</div>
									<div className="col icon">
										<i className="bi bi-brightness-low-fill"></i>
										<div className="label">brightness-low-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-brightness-low"></i>
										<div className="label">brightness-low</div>
									</div>
									<div className="col icon">
										<i className="bi bi-broadcast-pin"></i>
										<div className="label">broadcast-pin</div>
									</div>
									<div className="col icon">
										<i className="bi bi-broadcast"></i>
										<div className="label">broadcast</div>
									</div>
									<div className="col icon">
										<i className="bi bi-brush-fill"></i>
										<div className="label">brush-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-brush"></i>
										<div className="label">brush</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bucket-fill"></i>
										<div className="label">bucket-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bucket"></i>
										<div className="label">bucket</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bug-fill"></i>
										<div className="label">bug-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bug"></i>
										<div className="label">bug</div>
									</div>
									<div className="col icon">
										<i className="bi bi-building"></i>
										<div className="label">building</div>
									</div>
									<div className="col icon">
										<i className="bi bi-bullseye"></i>
										<div className="label">bullseye</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calculator-fill"></i>
										<div className="label">calculator-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calculator"></i>
										<div className="label">calculator</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar-check-fill"></i>
										<div className="label">calendar-check-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar-check"></i>
										<div className="label">calendar-check</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar-date-fill"></i>
										<div className="label">calendar-date-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar-date"></i>
										<div className="label">calendar-date</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar-day-fill"></i>
										<div className="label">calendar-day-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar-day"></i>
										<div className="label">calendar-day</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar-event-fill"></i>
										<div className="label">calendar-event-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar-event"></i>
										<div className="label">calendar-event</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar-fill"></i>
										<div className="label">calendar-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar-minus-fill"></i>
										<div className="label">calendar-minus-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar-minus"></i>
										<div className="label">calendar-minus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar-month-fill"></i>
										<div className="label">calendar-month-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar-month"></i>
										<div className="label">calendar-month</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar-plus-fill"></i>
										<div className="label">calendar-plus-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar-plus"></i>
										<div className="label">calendar-plus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar-range-fill"></i>
										<div className="label">calendar-range-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar-range"></i>
										<div className="label">calendar-range</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar-week-fill"></i>
										<div className="label">calendar-week-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar-week"></i>
										<div className="label">calendar-week</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar-x-fill"></i>
										<div className="label">calendar-x-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar-x"></i>
										<div className="label">calendar-x</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar"></i>
										<div className="label">calendar</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar2-check-fill"></i>
										<div className="label">calendar2-check-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar2-check"></i>
										<div className="label">calendar2-check</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar2-date-fill"></i>
										<div className="label">calendar2-date-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar2-date"></i>
										<div className="label">calendar2-date</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar2-day-fill"></i>
										<div className="label">calendar2-day-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar2-day"></i>
										<div className="label">calendar2-day</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar2-event-fill"></i>
										<div className="label">calendar2-event-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar2-event"></i>
										<div className="label">calendar2-event</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar2-fill"></i>
										<div className="label">calendar2-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar2-minus-fill"></i>
										<div className="label">calendar2-minus-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar2-minus"></i>
										<div className="label">calendar2-minus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar2-month-fill"></i>
										<div className="label">calendar2-month-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar2-month"></i>
										<div className="label">calendar2-month</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar2-plus-fill"></i>
										<div className="label">calendar2-plus-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar2-plus"></i>
										<div className="label">calendar2-plus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar2-range-fill"></i>
										<div className="label">calendar2-range-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar2-range"></i>
										<div className="label">calendar2-range</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar2-week-fill"></i>
										<div className="label">calendar2-week-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar2-week"></i>
										<div className="label">calendar2-week</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar2-x-fill"></i>
										<div className="label">calendar2-x-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar2-x"></i>
										<div className="label">calendar2-x</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar2"></i>
										<div className="label">calendar2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar3-event-fill"></i>
										<div className="label">calendar3-event-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar3-event"></i>
										<div className="label">calendar3-event</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar3-fill"></i>
										<div className="label">calendar3-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar3-range-fill"></i>
										<div className="label">calendar3-range-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar3-range"></i>
										<div className="label">calendar3-range</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar3-week-fill"></i>
										<div className="label">calendar3-week-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar3-week"></i>
										<div className="label">calendar3-week</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar3"></i>
										<div className="label">calendar3</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar4-event"></i>
										<div className="label">calendar4-event</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar4-range"></i>
										<div className="label">calendar4-range</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar4-week"></i>
										<div className="label">calendar4-week</div>
									</div>
									<div className="col icon">
										<i className="bi bi-calendar4"></i>
										<div className="label">calendar4</div>
									</div>
									<div className="col icon">
										<i className="bi bi-camera-fill"></i>
										<div className="label">camera-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-camera-reels-fill"></i>
										<div className="label">camera-reels-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-camera-reels"></i>
										<div className="label">camera-reels</div>
									</div>
									<div className="col icon">
										<i className="bi bi-camera-video-fill"></i>
										<div className="label">camera-video-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-camera-video-off-fill"></i>
										<div className="label">camera-video-off-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-camera-video-off"></i>
										<div className="label">camera-video-off</div>
									</div>
									<div className="col icon">
										<i className="bi bi-camera-video"></i>
										<div className="label">camera-video</div>
									</div>
									<div className="col icon">
										<i className="bi bi-camera"></i>
										<div className="label">camera</div>
									</div>
									<div className="col icon">
										<i className="bi bi-camera2"></i>
										<div className="label">camera2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-capslock-fill"></i>
										<div className="label">capslock-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-capslock"></i>
										<div className="label">capslock</div>
									</div>
									<div className="col icon">
										<i className="bi bi-card-checklist"></i>
										<div className="label">card-checklist</div>
									</div>
									<div className="col icon">
										<i className="bi bi-card-heading"></i>
										<div className="label">card-heading</div>
									</div>
									<div className="col icon">
										<i className="bi bi-card-image"></i>
										<div className="label">card-image</div>
									</div>
									<div className="col icon">
										<i className="bi bi-card-list"></i>
										<div className="label">card-list</div>
									</div>
									<div className="col icon">
										<i className="bi bi-card-text"></i>
										<div className="label">card-text</div>
									</div>
									<div className="col icon">
										<i className="bi bi-caret-down-fill"></i>
										<div className="label">caret-down-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-caret-down-square-fill"></i>
										<div className="label">caret-down-square-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-caret-down-square"></i>
										<div className="label">caret-down-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-caret-down"></i>
										<div className="label">caret-down</div>
									</div>
									<div className="col icon">
										<i className="bi bi-caret-left-fill"></i>
										<div className="label">caret-left-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-caret-left-square-fill"></i>
										<div className="label">caret-left-square-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-caret-left-square"></i>
										<div className="label">caret-left-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-caret-left"></i>
										<div className="label">caret-left</div>
									</div>
									<div className="col icon">
										<i className="bi bi-caret-right-fill"></i>
										<div className="label">caret-right-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-caret-right-square-fill"></i>
										<div className="label">caret-right-square-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-caret-right-square"></i>
										<div className="label">caret-right-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-caret-right"></i>
										<div className="label">caret-right</div>
									</div>
									<div className="col icon">
										<i className="bi bi-caret-up-fill"></i>
										<div className="label">caret-up-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-caret-up-square-fill"></i>
										<div className="label">caret-up-square-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-caret-up-square"></i>
										<div className="label">caret-up-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-caret-up"></i>
										<div className="label">caret-up</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cart-check-fill"></i>
										<div className="label">cart-check-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cart-check"></i>
										<div className="label">cart-check</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cart-dash-fill"></i>
										<div className="label">cart-dash-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cart-dash"></i>
										<div className="label">cart-dash</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cart-fill"></i>
										<div className="label">cart-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cart-plus-fill"></i>
										<div className="label">cart-plus-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cart-plus"></i>
										<div className="label">cart-plus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cart-x-fill"></i>
										<div className="label">cart-x-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cart-x"></i>
										<div className="label">cart-x</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cart"></i>
										<div className="label">cart</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cart2"></i>
										<div className="label">cart2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cart3"></i>
										<div className="label">cart3</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cart4"></i>
										<div className="label">cart4</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cash-coin"></i>
										<div className="label">cash-coin</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cash-stack"></i>
										<div className="label">cash-stack</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cash"></i>
										<div className="label">cash</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cast"></i>
										<div className="label">cast</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-dots-fill"></i>
										<div className="label">chat-dots-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-dots"></i>
										<div className="label">chat-dots</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-fill"></i>
										<div className="label">chat-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-left-dots-fill"></i>
										<div className="label">chat-left-dots-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-left-dots"></i>
										<div className="label">chat-left-dots</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-left-fill"></i>
										<div className="label">chat-left-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-left-quote-fill"></i>
										<div className="label">chat-left-quote-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-left-quote"></i>
										<div className="label">chat-left-quote</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-left-text-fill"></i>
										<div className="label">chat-left-text-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-left-text"></i>
										<div className="label">chat-left-text</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-left"></i>
										<div className="label">chat-left</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-quote-fill"></i>
										<div className="label">chat-quote-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-quote"></i>
										<div className="label">chat-quote</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-right-dots-fill"></i>
										<div className="label">chat-right-dots-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-right-dots"></i>
										<div className="label">chat-right-dots</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-right-fill"></i>
										<div className="label">chat-right-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-right-quote-fill"></i>
										<div className="label">chat-right-quote-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-right-quote"></i>
										<div className="label">chat-right-quote</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-right-text-fill"></i>
										<div className="label">chat-right-text-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-right-text"></i>
										<div className="label">chat-right-text</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-right"></i>
										<div className="label">chat-right</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-square-dots-fill"></i>
										<div className="label">chat-square-dots-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-square-dots"></i>
										<div className="label">chat-square-dots</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-square-fill"></i>
										<div className="label">chat-square-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-square-quote-fill"></i>
										<div className="label">chat-square-quote-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-square-quote"></i>
										<div className="label">chat-square-quote</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-square-text-fill"></i>
										<div className="label">chat-square-text-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-square-text"></i>
										<div className="label">chat-square-text</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-square"></i>
										<div className="label">chat-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-text-fill"></i>
										<div className="label">chat-text-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat-text"></i>
										<div className="label">chat-text</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chat"></i>
										<div className="label">chat</div>
									</div>
									<div className="col icon">
										<i className="bi bi-check-all"></i>
										<div className="label">check-all</div>
									</div>
									<div className="col icon">
										<i className="bi bi-check-circle-fill"></i>
										<div className="label">check-circle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-check-circle"></i>
										<div className="label">check-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-check-lg"></i>
										<div className="label">check-lg</div>
									</div>
									<div className="col icon">
										<i className="bi bi-check-square-fill"></i>
										<div className="label">check-square-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-check-square"></i>
										<div className="label">check-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-check"></i>
										<div className="label">check</div>
									</div>
									<div className="col icon">
										<i className="bi bi-check2-all"></i>
										<div className="label">check2-all</div>
									</div>
									<div className="col icon">
										<i className="bi bi-check2-circle"></i>
										<div className="label">check2-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-check2-square"></i>
										<div className="label">check2-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-check2"></i>
										<div className="label">check2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chevron-bar-contract"></i>
										<div className="label">chevron-bar-contract</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chevron-bar-down"></i>
										<div className="label">chevron-bar-down</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chevron-bar-expand"></i>
										<div className="label">chevron-bar-expand</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chevron-bar-left"></i>
										<div className="label">chevron-bar-left</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chevron-bar-right"></i>
										<div className="label">chevron-bar-right</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chevron-bar-up"></i>
										<div className="label">chevron-bar-up</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chevron-compact-down"></i>
										<div className="label">chevron-compact-down</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chevron-compact-left"></i>
										<div className="label">chevron-compact-left</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chevron-compact-right"></i>
										<div className="label">chevron-compact-right</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chevron-compact-up"></i>
										<div className="label">chevron-compact-up</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chevron-contract"></i>
										<div className="label">chevron-contract</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chevron-double-down"></i>
										<div className="label">chevron-double-down</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chevron-double-left"></i>
										<div className="label">chevron-double-left</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chevron-double-right"></i>
										<div className="label">chevron-double-right</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chevron-double-up"></i>
										<div className="label">chevron-double-up</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chevron-down"></i>
										<div className="label">chevron-down</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chevron-expand"></i>
										<div className="label">chevron-expand</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chevron-left"></i>
										<div className="label">chevron-left</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chevron-right"></i>
										<div className="label">chevron-right</div>
									</div>
									<div className="col icon">
										<i className="bi bi-chevron-up"></i>
										<div className="label">chevron-up</div>
									</div>
									<div className="col icon">
										<i className="bi bi-circle-fill"></i>
										<div className="label">circle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-circle-half"></i>
										<div className="label">circle-half</div>
									</div>
									<div className="col icon">
										<i className="bi bi-circle-square"></i>
										<div className="label">circle-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-circle"></i>
										<div className="label">circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-clipboard-check"></i>
										<div className="label">clipboard-check</div>
									</div>
									<div className="col icon">
										<i className="bi bi-clipboard-data"></i>
										<div className="label">clipboard-data</div>
									</div>
									<div className="col icon">
										<i className="bi bi-clipboard-minus"></i>
										<div className="label">clipboard-minus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-clipboard-plus"></i>
										<div className="label">clipboard-plus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-clipboard-x"></i>
										<div className="label">clipboard-x</div>
									</div>
									<div className="col icon">
										<i className="bi bi-clipboard"></i>
										<div className="label">clipboard</div>
									</div>
									<div className="col icon">
										<i className="bi bi-clock-fill"></i>
										<div className="label">clock-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-clock-history"></i>
										<div className="label">clock-history</div>
									</div>
									<div className="col icon">
										<i className="bi bi-clock"></i>
										<div className="label">clock</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-arrow-down-fill"></i>
										<div className="label">cloud-arrow-down-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-arrow-down"></i>
										<div className="label">cloud-arrow-down</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-arrow-up-fill"></i>
										<div className="label">cloud-arrow-up-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-arrow-up"></i>
										<div className="label">cloud-arrow-up</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-check-fill"></i>
										<div className="label">cloud-check-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-check"></i>
										<div className="label">cloud-check</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-download-fill"></i>
										<div className="label">cloud-download-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-download"></i>
										<div className="label">cloud-download</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-drizzle-fill"></i>
										<div className="label">cloud-drizzle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-drizzle"></i>
										<div className="label">cloud-drizzle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-fill"></i>
										<div className="label">cloud-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-fog-fill"></i>
										<div className="label">cloud-fog-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-fog"></i>
										<div className="label">cloud-fog</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-fog2-fill"></i>
										<div className="label">cloud-fog2-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-fog2"></i>
										<div className="label">cloud-fog2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-hail-fill"></i>
										<div className="label">cloud-hail-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-hail"></i>
										<div className="label">cloud-hail</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-haze-1"></i>
										<div className="label">cloud-haze-1</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-haze-fill"></i>
										<div className="label">cloud-haze-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-haze"></i>
										<div className="label">cloud-haze</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-haze2-fill"></i>
										<div className="label">cloud-haze2-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-lightning-fill"></i>
										<div className="label">cloud-lightning-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-lightning-rain-fill"></i>
										<div className="label">cloud-lightning-rain-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-lightning-rain"></i>
										<div className="label">cloud-lightning-rain</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-lightning"></i>
										<div className="label">cloud-lightning</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-minus-fill"></i>
										<div className="label">cloud-minus-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-minus"></i>
										<div className="label">cloud-minus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-moon-fill"></i>
										<div className="label">cloud-moon-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-moon"></i>
										<div className="label">cloud-moon</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-plus-fill"></i>
										<div className="label">cloud-plus-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-plus"></i>
										<div className="label">cloud-plus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-rain-fill"></i>
										<div className="label">cloud-rain-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-rain-heavy-fill"></i>
										<div className="label">cloud-rain-heavy-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-rain-heavy"></i>
										<div className="label">cloud-rain-heavy</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-rain"></i>
										<div className="label">cloud-rain</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-slash-fill"></i>
										<div className="label">cloud-slash-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-slash"></i>
										<div className="label">cloud-slash</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-sleet-fill"></i>
										<div className="label">cloud-sleet-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-sleet"></i>
										<div className="label">cloud-sleet</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-snow-fill"></i>
										<div className="label">cloud-snow-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-snow"></i>
										<div className="label">cloud-snow</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-sun-fill"></i>
										<div className="label">cloud-sun-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-sun"></i>
										<div className="label">cloud-sun</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-upload-fill"></i>
										<div className="label">cloud-upload-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud-upload"></i>
										<div className="label">cloud-upload</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloud"></i>
										<div className="label">cloud</div>
									</div>
									<div className="col icon">
										<i className="bi bi-clouds-fill"></i>
										<div className="label">clouds-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-clouds"></i>
										<div className="label">clouds</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloudy-fill"></i>
										<div className="label">cloudy-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cloudy"></i>
										<div className="label">cloudy</div>
									</div>
									<div className="col icon">
										<i className="bi bi-code-slash"></i>
										<div className="label">code-slash</div>
									</div>
									<div className="col icon">
										<i className="bi bi-code-square"></i>
										<div className="label">code-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-code"></i>
										<div className="label">code</div>
									</div>
									<div className="col icon">
										<i className="bi bi-coin"></i>
										<div className="label">coin</div>
									</div>
									<div className="col icon">
										<i className="bi bi-collection-fill"></i>
										<div className="label">collection-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-collection-play-fill"></i>
										<div className="label">collection-play-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-collection-play"></i>
										<div className="label">collection-play</div>
									</div>
									<div className="col icon">
										<i className="bi bi-collection"></i>
										<div className="label">collection</div>
									</div>
									<div className="col icon">
										<i className="bi bi-columns-gap"></i>
										<div className="label">columns-gap</div>
									</div>
									<div className="col icon">
										<i className="bi bi-columns"></i>
										<div className="label">columns</div>
									</div>
									<div className="col icon">
										<i className="bi bi-command"></i>
										<div className="label">command</div>
									</div>
									<div className="col icon">
										<i className="bi bi-compass-fill"></i>
										<div className="label">compass-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-compass"></i>
										<div className="label">compass</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cone-striped"></i>
										<div className="label">cone-striped</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cone"></i>
										<div className="label">cone</div>
									</div>
									<div className="col icon">
										<i className="bi bi-controller"></i>
										<div className="label">controller</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cpu-fill"></i>
										<div className="label">cpu-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cpu"></i>
										<div className="label">cpu</div>
									</div>
									<div className="col icon">
										<i className="bi bi-credit-card-2-back-fill"></i>
										<div className="label">credit-card-2-back-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-credit-card-2-back"></i>
										<div className="label">credit-card-2-back</div>
									</div>
									<div className="col icon">
										<i className="bi bi-credit-card-2-front-fill"></i>
										<div className="label">credit-card-2-front-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-credit-card-2-front"></i>
										<div className="label">credit-card-2-front</div>
									</div>
									<div className="col icon">
										<i className="bi bi-credit-card-fill"></i>
										<div className="label">credit-card-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-credit-card"></i>
										<div className="label">credit-card</div>
									</div>
									<div className="col icon">
										<i className="bi bi-crop"></i>
										<div className="label">crop</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cup-fill"></i>
										<div className="label">cup-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cup-straw"></i>
										<div className="label">cup-straw</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cup"></i>
										<div className="label">cup</div>
									</div>
									<div className="col icon">
										<i className="bi bi-currency-bitcoin"></i>
										<div className="label">currency-bitcoin</div>
									</div>
									<div className="col icon">
										<i className="bi bi-currency-dollar"></i>
										<div className="label">currency-dollar</div>
									</div>
									<div className="col icon">
										<i className="bi bi-currency-euro"></i>
										<div className="label">currency-euro</div>
									</div>
									<div className="col icon">
										<i className="bi bi-currency-exchange"></i>
										<div className="label">currency-exchange</div>
									</div>
									<div className="col icon">
										<i className="bi bi-currency-pound"></i>
										<div className="label">currency-pound</div>
									</div>
									<div className="col icon">
										<i className="bi bi-currency-yen"></i>
										<div className="label">currency-yen</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cursor-fill"></i>
										<div className="label">cursor-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cursor-text"></i>
										<div className="label">cursor-text</div>
									</div>
									<div className="col icon">
										<i className="bi bi-cursor"></i>
										<div className="label">cursor</div>
									</div>
									<div className="col icon">
										<i className="bi bi-dash-circle-dotted"></i>
										<div className="label">dash-circle-dotted</div>
									</div>
									<div className="col icon">
										<i className="bi bi-dash-circle-fill"></i>
										<div className="label">dash-circle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-dash-circle"></i>
										<div className="label">dash-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-dash-lg"></i>
										<div className="label">dash-lg</div>
									</div>
									<div className="col icon">
										<i className="bi bi-dash-square-dotted"></i>
										<div className="label">dash-square-dotted</div>
									</div>
									<div className="col icon">
										<i className="bi bi-dash-square-fill"></i>
										<div className="label">dash-square-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-dash-square"></i>
										<div className="label">dash-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-dash"></i>
										<div className="label">dash</div>
									</div>
									<div className="col icon">
										<i className="bi bi-diagram-2-fill"></i>
										<div className="label">diagram-2-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-diagram-2"></i>
										<div className="label">diagram-2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-diagram-3-fill"></i>
										<div className="label">diagram-3-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-diagram-3"></i>
										<div className="label">diagram-3</div>
									</div>
									<div className="col icon">
										<i className="bi bi-diamond-fill"></i>
										<div className="label">diamond-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-diamond-half"></i>
										<div className="label">diamond-half</div>
									</div>
									<div className="col icon">
										<i className="bi bi-diamond"></i>
										<div className="label">diamond</div>
									</div>
									<div className="col icon">
										<i className="bi bi-dice-1-fill"></i>
										<div className="label">dice-1-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-dice-1"></i>
										<div className="label">dice-1</div>
									</div>
									<div className="col icon">
										<i className="bi bi-dice-2-fill"></i>
										<div className="label">dice-2-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-dice-2"></i>
										<div className="label">dice-2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-dice-3-fill"></i>
										<div className="label">dice-3-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-dice-3"></i>
										<div className="label">dice-3</div>
									</div>
									<div className="col icon">
										<i className="bi bi-dice-4-fill"></i>
										<div className="label">dice-4-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-dice-4"></i>
										<div className="label">dice-4</div>
									</div>
									<div className="col icon">
										<i className="bi bi-dice-5-fill"></i>
										<div className="label">dice-5-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-dice-5"></i>
										<div className="label">dice-5</div>
									</div>
									<div className="col icon">
										<i className="bi bi-dice-6-fill"></i>
										<div className="label">dice-6-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-dice-6"></i>
										<div className="label">dice-6</div>
									</div>
									<div className="col icon">
										<i className="bi bi-disc-fill"></i>
										<div className="label">disc-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-disc"></i>
										<div className="label">disc</div>
									</div>
									<div className="col icon">
										<i className="bi bi-discord"></i>
										<div className="label">discord</div>
									</div>
									<div className="col icon">
										<i className="bi bi-display-fill"></i>
										<div className="label">display-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-display"></i>
										<div className="label">display</div>
									</div>
									<div className="col icon">
										<i className="bi bi-distribute-horizontal"></i>
										<div className="label">distribute-horizontal</div>
									</div>
									<div className="col icon">
										<i className="bi bi-distribute-vertical"></i>
										<div className="label">distribute-vertical</div>
									</div>
									<div className="col icon">
										<i className="bi bi-door-closed-fill"></i>
										<div className="label">door-closed-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-door-closed"></i>
										<div className="label">door-closed</div>
									</div>
									<div className="col icon">
										<i className="bi bi-door-open-fill"></i>
										<div className="label">door-open-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-door-open"></i>
										<div className="label">door-open</div>
									</div>
									<div className="col icon">
										<i className="bi bi-dot"></i>
										<div className="label">dot</div>
									</div>
									<div className="col icon">
										<i className="bi bi-download"></i>
										<div className="label">download</div>
									</div>
									<div className="col icon">
										<i className="bi bi-droplet-fill"></i>
										<div className="label">droplet-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-droplet-half"></i>
										<div className="label">droplet-half</div>
									</div>
									<div className="col icon">
										<i className="bi bi-droplet"></i>
										<div className="label">droplet</div>
									</div>
									<div className="col icon">
										<i className="bi bi-earbuds"></i>
										<div className="label">earbuds</div>
									</div>
									<div className="col icon">
										<i className="bi bi-easel-fill"></i>
										<div className="label">easel-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-easel"></i>
										<div className="label">easel</div>
									</div>
									<div className="col icon">
										<i className="bi bi-egg-fill"></i>
										<div className="label">egg-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-egg-fried"></i>
										<div className="label">egg-fried</div>
									</div>
									<div className="col icon">
										<i className="bi bi-egg"></i>
										<div className="label">egg</div>
									</div>
									<div className="col icon">
										<i className="bi bi-eject-fill"></i>
										<div className="label">eject-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-eject"></i>
										<div className="label">eject</div>
									</div>
									<div className="col icon">
										<i className="bi bi-emoji-angry-fill"></i>
										<div className="label">emoji-angry-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-emoji-angry"></i>
										<div className="label">emoji-angry</div>
									</div>
									<div className="col icon">
										<i className="bi bi-emoji-dizzy-fill"></i>
										<div className="label">emoji-dizzy-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-emoji-dizzy"></i>
										<div className="label">emoji-dizzy</div>
									</div>
									<div className="col icon">
										<i className="bi bi-emoji-expressionless-fill"></i>
										<div className="label">emoji-expressionless-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-emoji-expressionless"></i>
										<div className="label">emoji-expressionless</div>
									</div>
									<div className="col icon">
										<i className="bi bi-emoji-frown-fill"></i>
										<div className="label">emoji-frown-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-emoji-frown"></i>
										<div className="label">emoji-frown</div>
									</div>
									<div className="col icon">
										<i className="bi bi-emoji-heart-eyes-fill"></i>
										<div className="label">emoji-heart-eyes-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-emoji-heart-eyes"></i>
										<div className="label">emoji-heart-eyes</div>
									</div>
									<div className="col icon">
										<i className="bi bi-emoji-laughing-fill"></i>
										<div className="label">emoji-laughing-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-emoji-laughing"></i>
										<div className="label">emoji-laughing</div>
									</div>
									<div className="col icon">
										<i className="bi bi-emoji-neutral-fill"></i>
										<div className="label">emoji-neutral-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-emoji-neutral"></i>
										<div className="label">emoji-neutral</div>
									</div>
									<div className="col icon">
										<i className="bi bi-emoji-smile-fill"></i>
										<div className="label">emoji-smile-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-emoji-smile-upside-down-fill"></i>
										<div className="label">emoji-smile-upside-down-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-emoji-smile-upside-down"></i>
										<div className="label">emoji-smile-upside-down</div>
									</div>
									<div className="col icon">
										<i className="bi bi-emoji-smile"></i>
										<div className="label">emoji-smile</div>
									</div>
									<div className="col icon">
										<i className="bi bi-emoji-sunglasses-fill"></i>
										<div className="label">emoji-sunglasses-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-emoji-sunglasses"></i>
										<div className="label">emoji-sunglasses</div>
									</div>
									<div className="col icon">
										<i className="bi bi-emoji-wink-fill"></i>
										<div className="label">emoji-wink-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-emoji-wink"></i>
										<div className="label">emoji-wink</div>
									</div>
									<div className="col icon">
										<i className="bi bi-envelope-fill"></i>
										<div className="label">envelope-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-envelope-open-fill"></i>
										<div className="label">envelope-open-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-envelope-open"></i>
										<div className="label">envelope-open</div>
									</div>
									<div className="col icon">
										<i className="bi bi-envelope"></i>
										<div className="label">envelope</div>
									</div>
									<div className="col icon">
										<i className="bi bi-eraser-fill"></i>
										<div className="label">eraser-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-eraser"></i>
										<div className="label">eraser</div>
									</div>
									<div className="col icon">
										<i className="bi bi-exclamation-circle-fill"></i>
										<div className="label">exclamation-circle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-exclamation-circle"></i>
										<div className="label">exclamation-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-exclamation-diamond-fill"></i>
										<div className="label">exclamation-diamond-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-exclamation-diamond"></i>
										<div className="label">exclamation-diamond</div>
									</div>
									<div className="col icon">
										<i className="bi bi-exclamation-lg"></i>
										<div className="label">exclamation-lg</div>
									</div>
									<div className="col icon">
										<i className="bi bi-exclamation-octagon-fill"></i>
										<div className="label">exclamation-octagon-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-exclamation-octagon"></i>
										<div className="label">exclamation-octagon</div>
									</div>
									<div className="col icon">
										<i className="bi bi-exclamation-square-fill"></i>
										<div className="label">exclamation-square-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-exclamation-square"></i>
										<div className="label">exclamation-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-exclamation-triangle-fill"></i>
										<div className="label">exclamation-triangle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-exclamation-triangle"></i>
										<div className="label">exclamation-triangle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-exclamation"></i>
										<div className="label">exclamation</div>
									</div>
									<div className="col icon">
										<i className="bi bi-exclude"></i>
										<div className="label">exclude</div>
									</div>
									<div className="col icon">
										<i className="bi bi-eye-fill"></i>
										<div className="label">eye-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-eye-slash-fill"></i>
										<div className="label">eye-slash-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-eye-slash"></i>
										<div className="label">eye-slash</div>
									</div>
									<div className="col icon">
										<i className="bi bi-eye"></i>
										<div className="label">eye</div>
									</div>
									<div className="col icon">
										<i className="bi bi-eyedropper"></i>
										<div className="label">eyedropper</div>
									</div>
									<div className="col icon">
										<i className="bi bi-eyeglasses"></i>
										<div className="label">eyeglasses</div>
									</div>
									<div className="col icon">
										<i className="bi bi-facebook"></i>
										<div className="label">facebook</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-arrow-down-fill"></i>
										<div className="label">file-arrow-down-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-arrow-down"></i>
										<div className="label">file-arrow-down</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-arrow-up-fill"></i>
										<div className="label">file-arrow-up-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-arrow-up"></i>
										<div className="label">file-arrow-up</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-bar-graph-fill"></i>
										<div className="label">file-bar-graph-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-bar-graph"></i>
										<div className="label">file-bar-graph</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-binary-fill"></i>
										<div className="label">file-binary-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-binary"></i>
										<div className="label">file-binary</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-break-fill"></i>
										<div className="label">file-break-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-break"></i>
										<div className="label">file-break</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-check-fill"></i>
										<div className="label">file-check-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-check"></i>
										<div className="label">file-check</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-code-fill"></i>
										<div className="label">file-code-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-code"></i>
										<div className="label">file-code</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-diff-fill"></i>
										<div className="label">file-diff-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-diff"></i>
										<div className="label">file-diff</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-arrow-down-fill"></i>
										<div className="label">file-earmark-arrow-down-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-arrow-down"></i>
										<div className="label">file-earmark-arrow-down</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-arrow-up-fill"></i>
										<div className="label">file-earmark-arrow-up-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-arrow-up"></i>
										<div className="label">file-earmark-arrow-up</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-bar-graph-fill"></i>
										<div className="label">file-earmark-bar-graph-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-bar-graph"></i>
										<div className="label">file-earmark-bar-graph</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-binary-fill"></i>
										<div className="label">file-earmark-binary-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-binary"></i>
										<div className="label">file-earmark-binary</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-break-fill"></i>
										<div className="label">file-earmark-break-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-break"></i>
										<div className="label">file-earmark-break</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-check-fill"></i>
										<div className="label">file-earmark-check-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-check"></i>
										<div className="label">file-earmark-check</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-code-fill"></i>
										<div className="label">file-earmark-code-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-code"></i>
										<div className="label">file-earmark-code</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-diff-fill"></i>
										<div className="label">file-earmark-diff-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-diff"></i>
										<div className="label">file-earmark-diff</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-easel-fill"></i>
										<div className="label">file-earmark-easel-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-easel"></i>
										<div className="label">file-earmark-easel</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-excel-fill"></i>
										<div className="label">file-earmark-excel-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-excel"></i>
										<div className="label">file-earmark-excel</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-fill"></i>
										<div className="label">file-earmark-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-font-fill"></i>
										<div className="label">file-earmark-font-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-font"></i>
										<div className="label">file-earmark-font</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-image-fill"></i>
										<div className="label">file-earmark-image-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-image"></i>
										<div className="label">file-earmark-image</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-lock-fill"></i>
										<div className="label">file-earmark-lock-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-lock"></i>
										<div className="label">file-earmark-lock</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-lock2-fill"></i>
										<div className="label">file-earmark-lock2-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-lock2"></i>
										<div className="label">file-earmark-lock2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-medical-fill"></i>
										<div className="label">file-earmark-medical-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-medical"></i>
										<div className="label">file-earmark-medical</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-minus-fill"></i>
										<div className="label">file-earmark-minus-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-minus"></i>
										<div className="label">file-earmark-minus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-music-fill"></i>
										<div className="label">file-earmark-music-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-music"></i>
										<div className="label">file-earmark-music</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-pdf-fill"></i>
										<div className="label">file-earmark-pdf-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-pdf"></i>
										<div className="label">file-earmark-pdf</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-person-fill"></i>
										<div className="label">file-earmark-person-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-person"></i>
										<div className="label">file-earmark-person</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-play-fill"></i>
										<div className="label">file-earmark-play-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-play"></i>
										<div className="label">file-earmark-play</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-plus-fill"></i>
										<div className="label">file-earmark-plus-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-plus"></i>
										<div className="label">file-earmark-plus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-post-fill"></i>
										<div className="label">file-earmark-post-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-post"></i>
										<div className="label">file-earmark-post</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-ppt-fill"></i>
										<div className="label">file-earmark-ppt-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-ppt"></i>
										<div className="label">file-earmark-ppt</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-richtext-fill"></i>
										<div className="label">file-earmark-richtext-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-richtext"></i>
										<div className="label">file-earmark-richtext</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-ruled-fill"></i>
										<div className="label">file-earmark-ruled-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-ruled"></i>
										<div className="label">file-earmark-ruled</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-slides-fill"></i>
										<div className="label">file-earmark-slides-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-slides"></i>
										<div className="label">file-earmark-slides</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-spreadsheet-fill"></i>
										<div className="label">file-earmark-spreadsheet-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-spreadsheet"></i>
										<div className="label">file-earmark-spreadsheet</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-text-fill"></i>
										<div className="label">file-earmark-text-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-text"></i>
										<div className="label">file-earmark-text</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-word-fill"></i>
										<div className="label">file-earmark-word-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-word"></i>
										<div className="label">file-earmark-word</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-x-fill"></i>
										<div className="label">file-earmark-x-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-x"></i>
										<div className="label">file-earmark-x</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-zip-fill"></i>
										<div className="label">file-earmark-zip-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark-zip"></i>
										<div className="label">file-earmark-zip</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-earmark"></i>
										<div className="label">file-earmark</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-easel-fill"></i>
										<div className="label">file-easel-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-easel"></i>
										<div className="label">file-easel</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-excel-fill"></i>
										<div className="label">file-excel-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-excel"></i>
										<div className="label">file-excel</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-fill"></i>
										<div className="label">file-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-font-fill"></i>
										<div className="label">file-font-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-font"></i>
										<div className="label">file-font</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-image-fill"></i>
										<div className="label">file-image-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-image"></i>
										<div className="label">file-image</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-lock-fill"></i>
										<div className="label">file-lock-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-lock"></i>
										<div className="label">file-lock</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-lock2-fill"></i>
										<div className="label">file-lock2-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-lock2"></i>
										<div className="label">file-lock2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-medical-fill"></i>
										<div className="label">file-medical-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-medical"></i>
										<div className="label">file-medical</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-minus-fill"></i>
										<div className="label">file-minus-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-minus"></i>
										<div className="label">file-minus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-music-fill"></i>
										<div className="label">file-music-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-music"></i>
										<div className="label">file-music</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-pdf-fill"></i>
										<div className="label">file-pdf-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-pdf"></i>
										<div className="label">file-pdf</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-person-fill"></i>
										<div className="label">file-person-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-person"></i>
										<div className="label">file-person</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-play-fill"></i>
										<div className="label">file-play-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-play"></i>
										<div className="label">file-play</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-plus-fill"></i>
										<div className="label">file-plus-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-plus"></i>
										<div className="label">file-plus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-post-fill"></i>
										<div className="label">file-post-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-post"></i>
										<div className="label">file-post</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-ppt-fill"></i>
										<div className="label">file-ppt-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-ppt"></i>
										<div className="label">file-ppt</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-richtext-fill"></i>
										<div className="label">file-richtext-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-richtext"></i>
										<div className="label">file-richtext</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-ruled-fill"></i>
										<div className="label">file-ruled-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-ruled"></i>
										<div className="label">file-ruled</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-slides-fill"></i>
										<div className="label">file-slides-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-slides"></i>
										<div className="label">file-slides</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-spreadsheet-fill"></i>
										<div className="label">file-spreadsheet-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-spreadsheet"></i>
										<div className="label">file-spreadsheet</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-text-fill"></i>
										<div className="label">file-text-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-text"></i>
										<div className="label">file-text</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-word-fill"></i>
										<div className="label">file-word-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-word"></i>
										<div className="label">file-word</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-x-fill"></i>
										<div className="label">file-x-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-x"></i>
										<div className="label">file-x</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-zip-fill"></i>
										<div className="label">file-zip-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file-zip"></i>
										<div className="label">file-zip</div>
									</div>
									<div className="col icon">
										<i className="bi bi-file"></i>
										<div className="label">file</div>
									</div>
									<div className="col icon">
										<i className="bi bi-files-alt"></i>
										<div className="label">files-alt</div>
									</div>
									<div className="col icon">
										<i className="bi bi-files"></i>
										<div className="label">files</div>
									</div>
									<div className="col icon">
										<i className="bi bi-film"></i>
										<div className="label">film</div>
									</div>
									<div className="col icon">
										<i className="bi bi-filter-circle-fill"></i>
										<div className="label">filter-circle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-filter-circle"></i>
										<div className="label">filter-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-filter-left"></i>
										<div className="label">filter-left</div>
									</div>
									<div className="col icon">
										<i className="bi bi-filter-right"></i>
										<div className="label">filter-right</div>
									</div>
									<div className="col icon">
										<i className="bi bi-filter-square-fill"></i>
										<div className="label">filter-square-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-filter-square"></i>
										<div className="label">filter-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-filter"></i>
										<div className="label">filter</div>
									</div>
									<div className="col icon">
										<i className="bi bi-flag-fill"></i>
										<div className="label">flag-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-flag"></i>
										<div className="label">flag</div>
									</div>
									<div className="col icon">
										<i className="bi bi-flower1"></i>
										<div className="label">flower1</div>
									</div>
									<div className="col icon">
										<i className="bi bi-flower2"></i>
										<div className="label">flower2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-flower3"></i>
										<div className="label">flower3</div>
									</div>
									<div className="col icon">
										<i className="bi bi-folder-check"></i>
										<div className="label">folder-check</div>
									</div>
									<div className="col icon">
										<i className="bi bi-folder-fill"></i>
										<div className="label">folder-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-folder-minus"></i>
										<div className="label">folder-minus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-folder-plus"></i>
										<div className="label">folder-plus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-folder-symlink-fill"></i>
										<div className="label">folder-symlink-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-folder-symlink"></i>
										<div className="label">folder-symlink</div>
									</div>
									<div className="col icon">
										<i className="bi bi-folder-x"></i>
										<div className="label">folder-x</div>
									</div>
									<div className="col icon">
										<i className="bi bi-folder"></i>
										<div className="label">folder</div>
									</div>
									<div className="col icon">
										<i className="bi bi-folder2-open"></i>
										<div className="label">folder2-open</div>
									</div>
									<div className="col icon">
										<i className="bi bi-folder2"></i>
										<div className="label">folder2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-fonts"></i>
										<div className="label">fonts</div>
									</div>
									<div className="col icon">
										<i className="bi bi-forward-fill"></i>
										<div className="label">forward-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-forward"></i>
										<div className="label">forward</div>
									</div>
									<div className="col icon">
										<i className="bi bi-front"></i>
										<div className="label">front</div>
									</div>
									<div className="col icon">
										<i className="bi bi-fullscreen-exit"></i>
										<div className="label">fullscreen-exit</div>
									</div>
									<div className="col icon">
										<i className="bi bi-fullscreen"></i>
										<div className="label">fullscreen</div>
									</div>
									<div className="col icon">
										<i className="bi bi-funnel-fill"></i>
										<div className="label">funnel-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-funnel"></i>
										<div className="label">funnel</div>
									</div>
									<div className="col icon">
										<i className="bi bi-gear-fill"></i>
										<div className="label">gear-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-gear-wide-connected"></i>
										<div className="label">gear-wide-connected</div>
									</div>
									<div className="col icon">
										<i className="bi bi-gear-wide"></i>
										<div className="label">gear-wide</div>
									</div>
									<div className="col icon">
										<i className="bi bi-gear"></i>
										<div className="label">gear</div>
									</div>
									<div className="col icon">
										<i className="bi bi-gem"></i>
										<div className="label">gem</div>
									</div>
									<div className="col icon">
										<i className="bi bi-gender-ambiguous"></i>
										<div className="label">gender-ambiguous</div>
									</div>
									<div className="col icon">
										<i className="bi bi-gender-female"></i>
										<div className="label">gender-female</div>
									</div>
									<div className="col icon">
										<i className="bi bi-gender-male"></i>
										<div className="label">gender-male</div>
									</div>
									<div className="col icon">
										<i className="bi bi-gender-trans"></i>
										<div className="label">gender-trans</div>
									</div>
									<div className="col icon">
										<i className="bi bi-geo-alt-fill"></i>
										<div className="label">geo-alt-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-geo-alt"></i>
										<div className="label">geo-alt</div>
									</div>
									<div className="col icon">
										<i className="bi bi-geo-fill"></i>
										<div className="label">geo-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-geo"></i>
										<div className="label">geo</div>
									</div>
									<div className="col icon">
										<i className="bi bi-gift-fill"></i>
										<div className="label">gift-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-gift"></i>
										<div className="label">gift</div>
									</div>
									<div className="col icon">
										<i className="bi bi-github"></i>
										<div className="label">github</div>
									</div>
									<div className="col icon">
										<i className="bi bi-globe"></i>
										<div className="label">globe</div>
									</div>
									<div className="col icon">
										<i className="bi bi-globe2"></i>
										<div className="label">globe2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-google"></i>
										<div className="label">google</div>
									</div>
									<div className="col icon">
										<i className="bi bi-graph-down"></i>
										<div className="label">graph-down</div>
									</div>
									<div className="col icon">
										<i className="bi bi-graph-up"></i>
										<div className="label">graph-up</div>
									</div>
									<div className="col icon">
										<i className="bi bi-grid-1x2-fill"></i>
										<div className="label">grid-1x2-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-grid-1x2"></i>
										<div className="label">grid-1x2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-grid-3x2-gap-fill"></i>
										<div className="label">grid-3x2-gap-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-grid-3x2-gap"></i>
										<div className="label">grid-3x2-gap</div>
									</div>
									<div className="col icon">
										<i className="bi bi-grid-3x2"></i>
										<div className="label">grid-3x2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-grid-3x3-gap-fill"></i>
										<div className="label">grid-3x3-gap-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-grid-3x3-gap"></i>
										<div className="label">grid-3x3-gap</div>
									</div>
									<div className="col icon">
										<i className="bi bi-grid-3x3"></i>
										<div className="label">grid-3x3</div>
									</div>
									<div className="col icon">
										<i className="bi bi-grid-fill"></i>
										<div className="label">grid-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-grid"></i>
										<div className="label">grid</div>
									</div>
									<div className="col icon">
										<i className="bi bi-grip-horizontal"></i>
										<div className="label">grip-horizontal</div>
									</div>
									<div className="col icon">
										<i className="bi bi-grip-vertical"></i>
										<div className="label">grip-vertical</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hammer"></i>
										<div className="label">hammer</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hand-index-fill"></i>
										<div className="label">hand-index-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hand-index-thumb-fill"></i>
										<div className="label">hand-index-thumb-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hand-index-thumb"></i>
										<div className="label">hand-index-thumb</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hand-index"></i>
										<div className="label">hand-index</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hand-thumbs-down-fill"></i>
										<div className="label">hand-thumbs-down-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hand-thumbs-down"></i>
										<div className="label">hand-thumbs-down</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hand-thumbs-up-fill"></i>
										<div className="label">hand-thumbs-up-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hand-thumbs-up"></i>
										<div className="label">hand-thumbs-up</div>
									</div>
									<div className="col icon">
										<i className="bi bi-handbag-fill"></i>
										<div className="label">handbag-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-handbag"></i>
										<div className="label">handbag</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hash"></i>
										<div className="label">hash</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hdd-fill"></i>
										<div className="label">hdd-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hdd-network-fill"></i>
										<div className="label">hdd-network-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hdd-network"></i>
										<div className="label">hdd-network</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hdd-rack-fill"></i>
										<div className="label">hdd-rack-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hdd-rack"></i>
										<div className="label">hdd-rack</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hdd-stack-fill"></i>
										<div className="label">hdd-stack-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hdd-stack"></i>
										<div className="label">hdd-stack</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hdd"></i>
										<div className="label">hdd</div>
									</div>
									<div className="col icon">
										<i className="bi bi-headphones"></i>
										<div className="label">headphones</div>
									</div>
									<div className="col icon">
										<i className="bi bi-headset-vr"></i>
										<div className="label">headset-vr</div>
									</div>
									<div className="col icon">
										<i className="bi bi-headset"></i>
										<div className="label">headset</div>
									</div>
									<div className="col icon">
										<i className="bi bi-heart-fill"></i>
										<div className="label">heart-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-heart-half"></i>
										<div className="label">heart-half</div>
									</div>
									<div className="col icon">
										<i className="bi bi-heart"></i>
										<div className="label">heart</div>
									</div>
									<div className="col icon">
										<i className="bi bi-heptagon-fill"></i>
										<div className="label">heptagon-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-heptagon-half"></i>
										<div className="label">heptagon-half</div>
									</div>
									<div className="col icon">
										<i className="bi bi-heptagon"></i>
										<div className="label">heptagon</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hexagon-fill"></i>
										<div className="label">hexagon-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hexagon-half"></i>
										<div className="label">hexagon-half</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hexagon"></i>
										<div className="label">hexagon</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hourglass-bottom"></i>
										<div className="label">hourglass-bottom</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hourglass-split"></i>
										<div className="label">hourglass-split</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hourglass-top"></i>
										<div className="label">hourglass-top</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hourglass"></i>
										<div className="label">hourglass</div>
									</div>
									<div className="col icon">
										<i className="bi bi-house-door-fill"></i>
										<div className="label">house-door-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-house-door"></i>
										<div className="label">house-door</div>
									</div>
									<div className="col icon">
										<i className="bi bi-house-fill"></i>
										<div className="label">house-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-house"></i>
										<div className="label">house</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hr"></i>
										<div className="label">hr</div>
									</div>
									<div className="col icon">
										<i className="bi bi-hurricane"></i>
										<div className="label">hurricane</div>
									</div>
									<div className="col icon">
										<i className="bi bi-image-alt"></i>
										<div className="label">image-alt</div>
									</div>
									<div className="col icon">
										<i className="bi bi-image-fill"></i>
										<div className="label">image-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-image"></i>
										<div className="label">image</div>
									</div>
									<div className="col icon">
										<i className="bi bi-images"></i>
										<div className="label">images</div>
									</div>
									<div className="col icon">
										<i className="bi bi-inbox-fill"></i>
										<div className="label">inbox-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-inbox"></i>
										<div className="label">inbox</div>
									</div>
									<div className="col icon">
										<i className="bi bi-inboxes-fill"></i>
										<div className="label">inboxes-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-inboxes"></i>
										<div className="label">inboxes</div>
									</div>
									<div className="col icon">
										<i className="bi bi-info-circle-fill"></i>
										<div className="label">info-circle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-info-circle"></i>
										<div className="label">info-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-info-lg"></i>
										<div className="label">info-lg</div>
									</div>
									<div className="col icon">
										<i className="bi bi-info-square-fill"></i>
										<div className="label">info-square-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-info-square"></i>
										<div className="label">info-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-info"></i>
										<div className="label">info</div>
									</div>
									<div className="col icon">
										<i className="bi bi-input-cursor-text"></i>
										<div className="label">input-cursor-text</div>
									</div>
									<div className="col icon">
										<i className="bi bi-input-cursor"></i>
										<div className="label">input-cursor</div>
									</div>
									<div className="col icon">
										<i className="bi bi-instagram"></i>
										<div className="label">instagram</div>
									</div>
									<div className="col icon">
										<i className="bi bi-intersect"></i>
										<div className="label">intersect</div>
									</div>
									<div className="col icon">
										<i className="bi bi-journal-album"></i>
										<div className="label">journal-album</div>
									</div>
									<div className="col icon">
										<i className="bi bi-journal-arrow-down"></i>
										<div className="label">journal-arrow-down</div>
									</div>
									<div className="col icon">
										<i className="bi bi-journal-arrow-up"></i>
										<div className="label">journal-arrow-up</div>
									</div>
									<div className="col icon">
										<i className="bi bi-journal-bookmark-fill"></i>
										<div className="label">journal-bookmark-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-journal-bookmark"></i>
										<div className="label">journal-bookmark</div>
									</div>
									<div className="col icon">
										<i className="bi bi-journal-check"></i>
										<div className="label">journal-check</div>
									</div>
									<div className="col icon">
										<i className="bi bi-journal-code"></i>
										<div className="label">journal-code</div>
									</div>
									<div className="col icon">
										<i className="bi bi-journal-medical"></i>
										<div className="label">journal-medical</div>
									</div>
									<div className="col icon">
										<i className="bi bi-journal-minus"></i>
										<div className="label">journal-minus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-journal-plus"></i>
										<div className="label">journal-plus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-journal-richtext"></i>
										<div className="label">journal-richtext</div>
									</div>
									<div className="col icon">
										<i className="bi bi-journal-text"></i>
										<div className="label">journal-text</div>
									</div>
									<div className="col icon">
										<i className="bi bi-journal-x"></i>
										<div className="label">journal-x</div>
									</div>
									<div className="col icon">
										<i className="bi bi-journal"></i>
										<div className="label">journal</div>
									</div>
									<div className="col icon">
										<i className="bi bi-journals"></i>
										<div className="label">journals</div>
									</div>
									<div className="col icon">
										<i className="bi bi-joystick"></i>
										<div className="label">joystick</div>
									</div>
									<div className="col icon">
										<i className="bi bi-justify-left"></i>
										<div className="label">justify-left</div>
									</div>
									<div className="col icon">
										<i className="bi bi-justify-right"></i>
										<div className="label">justify-right</div>
									</div>
									<div className="col icon">
										<i className="bi bi-justify"></i>
										<div className="label">justify</div>
									</div>
									<div className="col icon">
										<i className="bi bi-kanban-fill"></i>
										<div className="label">kanban-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-kanban"></i>
										<div className="label">kanban</div>
									</div>
									<div className="col icon">
										<i className="bi bi-key-fill"></i>
										<div className="label">key-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-key"></i>
										<div className="label">key</div>
									</div>
									<div className="col icon">
										<i className="bi bi-keyboard-fill"></i>
										<div className="label">keyboard-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-keyboard"></i>
										<div className="label">keyboard</div>
									</div>
									<div className="col icon">
										<i className="bi bi-ladder"></i>
										<div className="label">ladder</div>
									</div>
									<div className="col icon">
										<i className="bi bi-lamp-fill"></i>
										<div className="label">lamp-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-lamp"></i>
										<div className="label">lamp</div>
									</div>
									<div className="col icon">
										<i className="bi bi-laptop-fill"></i>
										<div className="label">laptop-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-laptop"></i>
										<div className="label">laptop</div>
									</div>
									<div className="col icon">
										<i className="bi bi-layer-backward"></i>
										<div className="label">layer-backward</div>
									</div>
									<div className="col icon">
										<i className="bi bi-layer-forward"></i>
										<div className="label">layer-forward</div>
									</div>
									<div className="col icon">
										<i className="bi bi-layers-fill"></i>
										<div className="label">layers-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-layers-half"></i>
										<div className="label">layers-half</div>
									</div>
									<div className="col icon">
										<i className="bi bi-layers"></i>
										<div className="label">layers</div>
									</div>
									<div className="col icon">
										<i className="bi bi-layout-sidebar-inset-reverse"></i>
										<div className="label">layout-sidebar-inset-reverse</div>
									</div>
									<div className="col icon">
										<i className="bi bi-layout-sidebar-inset"></i>
										<div className="label">layout-sidebar-inset</div>
									</div>
									<div className="col icon">
										<i className="bi bi-layout-sidebar-reverse"></i>
										<div className="label">layout-sidebar-reverse</div>
									</div>
									<div className="col icon">
										<i className="bi bi-layout-sidebar"></i>
										<div className="label">layout-sidebar</div>
									</div>
									<div className="col icon">
										<i className="bi bi-layout-split"></i>
										<div className="label">layout-split</div>
									</div>
									<div className="col icon">
										<i className="bi bi-layout-text-sidebar-reverse"></i>
										<div className="label">layout-text-sidebar-reverse</div>
									</div>
									<div className="col icon">
										<i className="bi bi-layout-text-sidebar"></i>
										<div className="label">layout-text-sidebar</div>
									</div>
									<div className="col icon">
										<i className="bi bi-layout-text-window-reverse"></i>
										<div className="label">layout-text-window-reverse</div>
									</div>
									<div className="col icon">
										<i className="bi bi-layout-text-window"></i>
										<div className="label">layout-text-window</div>
									</div>
									<div className="col icon">
										<i className="bi bi-layout-three-columns"></i>
										<div className="label">layout-three-columns</div>
									</div>
									<div className="col icon">
										<i className="bi bi-layout-wtf"></i>
										<div className="label">layout-wtf</div>
									</div>
									<div className="col icon">
										<i className="bi bi-life-preserver"></i>
										<div className="label">life-preserver</div>
									</div>
									<div className="col icon">
										<i className="bi bi-lightbulb-fill"></i>
										<div className="label">lightbulb-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-lightbulb-off-fill"></i>
										<div className="label">lightbulb-off-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-lightbulb-off"></i>
										<div className="label">lightbulb-off</div>
									</div>
									<div className="col icon">
										<i className="bi bi-lightbulb"></i>
										<div className="label">lightbulb</div>
									</div>
									<div className="col icon">
										<i className="bi bi-lightning-charge-fill"></i>
										<div className="label">lightning-charge-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-lightning-charge"></i>
										<div className="label">lightning-charge</div>
									</div>
									<div className="col icon">
										<i className="bi bi-lightning-fill"></i>
										<div className="label">lightning-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-lightning"></i>
										<div className="label">lightning</div>
									</div>
									<div className="col icon">
										<i className="bi bi-link-45deg"></i>
										<div className="label">link-45deg</div>
									</div>
									<div className="col icon">
										<i className="bi bi-link"></i>
										<div className="label">link</div>
									</div>
									<div className="col icon">
										<i className="bi bi-linkedin"></i>
										<div className="label">linkedin</div>
									</div>
									<div className="col icon">
										<i className="bi bi-list-check"></i>
										<div className="label">list-check</div>
									</div>
									<div className="col icon">
										<i className="bi bi-list-nested"></i>
										<div className="label">list-nested</div>
									</div>
									<div className="col icon">
										<i className="bi bi-list-ol"></i>
										<div className="label">list-ol</div>
									</div>
									<div className="col icon">
										<i className="bi bi-list-stars"></i>
										<div className="label">list-stars</div>
									</div>
									<div className="col icon">
										<i className="bi bi-list-task"></i>
										<div className="label">list-task</div>
									</div>
									<div className="col icon">
										<i className="bi bi-list-ul"></i>
										<div className="label">list-ul</div>
									</div>
									<div className="col icon">
										<i className="bi bi-list"></i>
										<div className="label">list</div>
									</div>
									<div className="col icon">
										<i className="bi bi-lock-fill"></i>
										<div className="label">lock-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-lock"></i>
										<div className="label">lock</div>
									</div>
									<div className="col icon">
										<i className="bi bi-mailbox"></i>
										<div className="label">mailbox</div>
									</div>
									<div className="col icon">
										<i className="bi bi-mailbox2"></i>
										<div className="label">mailbox2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-map-fill"></i>
										<div className="label">map-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-map"></i>
										<div className="label">map</div>
									</div>
									<div className="col icon">
										<i className="bi bi-markdown-fill"></i>
										<div className="label">markdown-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-markdown"></i>
										<div className="label">markdown</div>
									</div>
									<div className="col icon">
										<i className="bi bi-mask"></i>
										<div className="label">mask</div>
									</div>
									<div className="col icon">
										<i className="bi bi-mastodon"></i>
										<div className="label">mastodon</div>
									</div>
									<div className="col icon">
										<i className="bi bi-megaphone-fill"></i>
										<div className="label">megaphone-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-megaphone"></i>
										<div className="label">megaphone</div>
									</div>
									<div className="col icon">
										<i className="bi bi-menu-app-fill"></i>
										<div className="label">menu-app-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-menu-app"></i>
										<div className="label">menu-app</div>
									</div>
									<div className="col icon">
										<i className="bi bi-menu-button-fill"></i>
										<div className="label">menu-button-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-menu-button-wide-fill"></i>
										<div className="label">menu-button-wide-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-menu-button-wide"></i>
										<div className="label">menu-button-wide</div>
									</div>
									<div className="col icon">
										<i className="bi bi-menu-button"></i>
										<div className="label">menu-button</div>
									</div>
									<div className="col icon">
										<i className="bi bi-menu-down"></i>
										<div className="label">menu-down</div>
									</div>
									<div className="col icon">
										<i className="bi bi-menu-up"></i>
										<div className="label">menu-up</div>
									</div>
									<div className="col icon">
										<i className="bi bi-messenger"></i>
										<div className="label">messenger</div>
									</div>
									<div className="col icon">
										<i className="bi bi-mic-fill"></i>
										<div className="label">mic-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-mic-mute-fill"></i>
										<div className="label">mic-mute-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-mic-mute"></i>
										<div className="label">mic-mute</div>
									</div>
									<div className="col icon">
										<i className="bi bi-mic"></i>
										<div className="label">mic</div>
									</div>
									<div className="col icon">
										<i className="bi bi-minecart-loaded"></i>
										<div className="label">minecart-loaded</div>
									</div>
									<div className="col icon">
										<i className="bi bi-minecart"></i>
										<div className="label">minecart</div>
									</div>
									<div className="col icon">
										<i className="bi bi-moisture"></i>
										<div className="label">moisture</div>
									</div>
									<div className="col icon">
										<i className="bi bi-moon-fill"></i>
										<div className="label">moon-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-moon-stars-fill"></i>
										<div className="label">moon-stars-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-moon-stars"></i>
										<div className="label">moon-stars</div>
									</div>
									<div className="col icon">
										<i className="bi bi-moon"></i>
										<div className="label">moon</div>
									</div>
									<div className="col icon">
										<i className="bi bi-mouse-fill"></i>
										<div className="label">mouse-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-mouse"></i>
										<div className="label">mouse</div>
									</div>
									<div className="col icon">
										<i className="bi bi-mouse2-fill"></i>
										<div className="label">mouse2-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-mouse2"></i>
										<div className="label">mouse2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-mouse3-fill"></i>
										<div className="label">mouse3-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-mouse3"></i>
										<div className="label">mouse3</div>
									</div>
									<div className="col icon">
										<i className="bi bi-music-note-beamed"></i>
										<div className="label">music-note-beamed</div>
									</div>
									<div className="col icon">
										<i className="bi bi-music-note-list"></i>
										<div className="label">music-note-list</div>
									</div>
									<div className="col icon">
										<i className="bi bi-music-note"></i>
										<div className="label">music-note</div>
									</div>
									<div className="col icon">
										<i className="bi bi-music-player-fill"></i>
										<div className="label">music-player-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-music-player"></i>
										<div className="label">music-player</div>
									</div>
									<div className="col icon">
										<i className="bi bi-newspaper"></i>
										<div className="label">newspaper</div>
									</div>
									<div className="col icon">
										<i className="bi bi-node-minus-fill"></i>
										<div className="label">node-minus-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-node-minus"></i>
										<div className="label">node-minus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-node-plus-fill"></i>
										<div className="label">node-plus-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-node-plus"></i>
										<div className="label">node-plus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-nut-fill"></i>
										<div className="label">nut-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-nut"></i>
										<div className="label">nut</div>
									</div>
									<div className="col icon">
										<i className="bi bi-octagon-fill"></i>
										<div className="label">octagon-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-octagon-half"></i>
										<div className="label">octagon-half</div>
									</div>
									<div className="col icon">
										<i className="bi bi-octagon"></i>
										<div className="label">octagon</div>
									</div>
									<div className="col icon">
										<i className="bi bi-option"></i>
										<div className="label">option</div>
									</div>
									<div className="col icon">
										<i className="bi bi-outlet"></i>
										<div className="label">outlet</div>
									</div>
									<div className="col icon">
										<i className="bi bi-paint-bucket"></i>
										<div className="label">paint-bucket</div>
									</div>
									<div className="col icon">
										<i className="bi bi-palette-fill"></i>
										<div className="label">palette-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-palette"></i>
										<div className="label">palette</div>
									</div>
									<div className="col icon">
										<i className="bi bi-palette2"></i>
										<div className="label">palette2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-paperclip"></i>
										<div className="label">paperclip</div>
									</div>
									<div className="col icon">
										<i className="bi bi-paragraph"></i>
										<div className="label">paragraph</div>
									</div>
									<div className="col icon">
										<i className="bi bi-patch-check-fill"></i>
										<div className="label">patch-check-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-patch-check"></i>
										<div className="label">patch-check</div>
									</div>
									<div className="col icon">
										<i className="bi bi-patch-exclamation-fill"></i>
										<div className="label">patch-exclamation-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-patch-exclamation"></i>
										<div className="label">patch-exclamation</div>
									</div>
									<div className="col icon">
										<i className="bi bi-patch-minus-fill"></i>
										<div className="label">patch-minus-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-patch-minus"></i>
										<div className="label">patch-minus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-patch-plus-fill"></i>
										<div className="label">patch-plus-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-patch-plus"></i>
										<div className="label">patch-plus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-patch-question-fill"></i>
										<div className="label">patch-question-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-patch-question"></i>
										<div className="label">patch-question</div>
									</div>
									<div className="col icon">
										<i className="bi bi-pause-btn-fill"></i>
										<div className="label">pause-btn-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-pause-btn"></i>
										<div className="label">pause-btn</div>
									</div>
									<div className="col icon">
										<i className="bi bi-pause-circle-fill"></i>
										<div className="label">pause-circle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-pause-circle"></i>
										<div className="label">pause-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-pause-fill"></i>
										<div className="label">pause-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-pause"></i>
										<div className="label">pause</div>
									</div>
									<div className="col icon">
										<i className="bi bi-peace-fill"></i>
										<div className="label">peace-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-peace"></i>
										<div className="label">peace</div>
									</div>
									<div className="col icon">
										<i className="bi bi-pen-fill"></i>
										<div className="label">pen-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-pen"></i>
										<div className="label">pen</div>
									</div>
									<div className="col icon">
										<i className="bi bi-pencil-fill"></i>
										<div className="label">pencil-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-pencil-square"></i>
										<div className="label">pencil-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-pencil"></i>
										<div className="label">pencil</div>
									</div>
									<div className="col icon">
										<i className="bi bi-pentagon-fill"></i>
										<div className="label">pentagon-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-pentagon-half"></i>
										<div className="label">pentagon-half</div>
									</div>
									<div className="col icon">
										<i className="bi bi-pentagon"></i>
										<div className="label">pentagon</div>
									</div>
									<div className="col icon">
										<i className="bi bi-people-fill"></i>
										<div className="label">people-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-people"></i>
										<div className="label">people</div>
									</div>
									<div className="col icon">
										<i className="bi bi-percent"></i>
										<div className="label">percent</div>
									</div>
									<div className="col icon">
										<i className="bi bi-person-badge-fill"></i>
										<div className="label">person-badge-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-person-badge"></i>
										<div className="label">person-badge</div>
									</div>
									<div className="col icon">
										<i className="bi bi-person-bounding-box"></i>
										<div className="label">person-bounding-box</div>
									</div>
									<div className="col icon">
										<i className="bi bi-person-check-fill"></i>
										<div className="label">person-check-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-person-check"></i>
										<div className="label">person-check</div>
									</div>
									<div className="col icon">
										<i className="bi bi-person-circle"></i>
										<div className="label">person-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-person-dash-fill"></i>
										<div className="label">person-dash-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-person-dash"></i>
										<div className="label">person-dash</div>
									</div>
									<div className="col icon">
										<i className="bi bi-person-fill"></i>
										<div className="label">person-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-person-lines-fill"></i>
										<div className="label">person-lines-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-person-plus-fill"></i>
										<div className="label">person-plus-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-person-plus"></i>
										<div className="label">person-plus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-person-square"></i>
										<div className="label">person-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-person-x-fill"></i>
										<div className="label">person-x-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-person-x"></i>
										<div className="label">person-x</div>
									</div>
									<div className="col icon">
										<i className="bi bi-person"></i>
										<div className="label">person</div>
									</div>
									<div className="col icon">
										<i className="bi bi-phone-fill"></i>
										<div className="label">phone-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-phone-landscape-fill"></i>
										<div className="label">phone-landscape-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-phone-landscape"></i>
										<div className="label">phone-landscape</div>
									</div>
									<div className="col icon">
										<i className="bi bi-phone-vibrate-fill"></i>
										<div className="label">phone-vibrate-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-phone-vibrate"></i>
										<div className="label">phone-vibrate</div>
									</div>
									<div className="col icon">
										<i className="bi bi-phone"></i>
										<div className="label">phone</div>
									</div>
									<div className="col icon">
										<i className="bi bi-pie-chart-fill"></i>
										<div className="label">pie-chart-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-pie-chart"></i>
										<div className="label">pie-chart</div>
									</div>
									<div className="col icon">
										<i className="bi bi-piggy-bank-fill"></i>
										<div className="label">piggy-bank-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-piggy-bank"></i>
										<div className="label">piggy-bank</div>
									</div>
									<div className="col icon">
										<i className="bi bi-pin-angle-fill"></i>
										<div className="label">pin-angle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-pin-angle"></i>
										<div className="label">pin-angle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-pin-fill"></i>
										<div className="label">pin-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-pin-map-fill"></i>
										<div className="label">pin-map-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-pin-map"></i>
										<div className="label">pin-map</div>
									</div>
									<div className="col icon">
										<i className="bi bi-pin"></i>
										<div className="label">pin</div>
									</div>
									<div className="col icon">
										<i className="bi bi-pip-fill"></i>
										<div className="label">pip-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-pip"></i>
										<div className="label">pip</div>
									</div>
									<div className="col icon">
										<i className="bi bi-play-btn-fill"></i>
										<div className="label">play-btn-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-play-btn"></i>
										<div className="label">play-btn</div>
									</div>
									<div className="col icon">
										<i className="bi bi-play-circle-fill"></i>
										<div className="label">play-circle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-play-circle"></i>
										<div className="label">play-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-play-fill"></i>
										<div className="label">play-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-play"></i>
										<div className="label">play</div>
									</div>
									<div className="col icon">
										<i className="bi bi-plug-fill"></i>
										<div className="label">plug-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-plug"></i>
										<div className="label">plug</div>
									</div>
									<div className="col icon">
										<i className="bi bi-plus-circle-dotted"></i>
										<div className="label">plus-circle-dotted</div>
									</div>
									<div className="col icon">
										<i className="bi bi-plus-circle-fill"></i>
										<div className="label">plus-circle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-plus-circle"></i>
										<div className="label">plus-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-plus-lg"></i>
										<div className="label">plus-lg</div>
									</div>
									<div className="col icon">
										<i className="bi bi-plus-square-dotted"></i>
										<div className="label">plus-square-dotted</div>
									</div>
									<div className="col icon">
										<i className="bi bi-plus-square-fill"></i>
										<div className="label">plus-square-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-plus-square"></i>
										<div className="label">plus-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-plus"></i>
										<div className="label">plus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-power"></i>
										<div className="label">power</div>
									</div>
									<div className="col icon">
										<i className="bi bi-printer-fill"></i>
										<div className="label">printer-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-printer"></i>
										<div className="label">printer</div>
									</div>
									<div className="col icon">
										<i className="bi bi-puzzle-fill"></i>
										<div className="label">puzzle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-puzzle"></i>
										<div className="label">puzzle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-question-circle-fill"></i>
										<div className="label">question-circle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-question-circle"></i>
										<div className="label">question-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-question-diamond-fill"></i>
										<div className="label">question-diamond-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-question-diamond"></i>
										<div className="label">question-diamond</div>
									</div>
									<div className="col icon">
										<i className="bi bi-question-lg"></i>
										<div className="label">question-lg</div>
									</div>
									<div className="col icon">
										<i className="bi bi-question-octagon-fill"></i>
										<div className="label">question-octagon-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-question-octagon"></i>
										<div className="label">question-octagon</div>
									</div>
									<div className="col icon">
										<i className="bi bi-question-square-fill"></i>
										<div className="label">question-square-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-question-square"></i>
										<div className="label">question-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-question"></i>
										<div className="label">question</div>
									</div>
									<div className="col icon">
										<i className="bi bi-rainbow"></i>
										<div className="label">rainbow</div>
									</div>
									<div className="col icon">
										<i className="bi bi-receipt-cutoff"></i>
										<div className="label">receipt-cutoff</div>
									</div>
									<div className="col icon">
										<i className="bi bi-receipt"></i>
										<div className="label">receipt</div>
									</div>
									<div className="col icon">
										<i className="bi bi-reception-0"></i>
										<div className="label">reception-0</div>
									</div>
									<div className="col icon">
										<i className="bi bi-reception-1"></i>
										<div className="label">reception-1</div>
									</div>
									<div className="col icon">
										<i className="bi bi-reception-2"></i>
										<div className="label">reception-2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-reception-3"></i>
										<div className="label">reception-3</div>
									</div>
									<div className="col icon">
										<i className="bi bi-reception-4"></i>
										<div className="label">reception-4</div>
									</div>
									<div className="col icon">
										<i className="bi bi-record-btn-fill"></i>
										<div className="label">record-btn-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-record-btn"></i>
										<div className="label">record-btn</div>
									</div>
									<div className="col icon">
										<i className="bi bi-record-circle-fill"></i>
										<div className="label">record-circle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-record-circle"></i>
										<div className="label">record-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-record-fill"></i>
										<div className="label">record-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-record"></i>
										<div className="label">record</div>
									</div>
									<div className="col icon">
										<i className="bi bi-record2-fill"></i>
										<div className="label">record2-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-record2"></i>
										<div className="label">record2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-recycle"></i>
										<div className="label">recycle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-reddit"></i>
										<div className="label">reddit</div>
									</div>
									<div className="col icon">
										<i className="bi bi-reply-all-fill"></i>
										<div className="label">reply-all-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-reply-all"></i>
										<div className="label">reply-all</div>
									</div>
									<div className="col icon">
										<i className="bi bi-reply-fill"></i>
										<div className="label">reply-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-reply"></i>
										<div className="label">reply</div>
									</div>
									<div className="col icon">
										<i className="bi bi-rss-fill"></i>
										<div className="label">rss-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-rss"></i>
										<div className="label">rss</div>
									</div>
									<div className="col icon">
										<i className="bi bi-rulers"></i>
										<div className="label">rulers</div>
									</div>
									<div className="col icon">
										<i className="bi bi-safe-fill"></i>
										<div className="label">safe-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-safe"></i>
										<div className="label">safe</div>
									</div>
									<div className="col icon">
										<i className="bi bi-safe2-fill"></i>
										<div className="label">safe2-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-safe2"></i>
										<div className="label">safe2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-save-fill"></i>
										<div className="label">save-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-save"></i>
										<div className="label">save</div>
									</div>
									<div className="col icon">
										<i className="bi bi-save2-fill"></i>
										<div className="label">save2-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-save2"></i>
										<div className="label">save2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-scissors"></i>
										<div className="label">scissors</div>
									</div>
									<div className="col icon">
										<i className="bi bi-screwdriver"></i>
										<div className="label">screwdriver</div>
									</div>
									<div className="col icon">
										<i className="bi bi-sd-card-fill"></i>
										<div className="label">sd-card-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-sd-card"></i>
										<div className="label">sd-card</div>
									</div>
									<div className="col icon">
										<i className="bi bi-search"></i>
										<div className="label">search</div>
									</div>
									<div className="col icon">
										<i className="bi bi-segmented-nav"></i>
										<div className="label">segmented-nav</div>
									</div>
									<div className="col icon">
										<i className="bi bi-server"></i>
										<div className="label">server</div>
									</div>
									<div className="col icon">
										<i className="bi bi-share-fill"></i>
										<div className="label">share-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-share"></i>
										<div className="label">share</div>
									</div>
									<div className="col icon">
										<i className="bi bi-shield-check"></i>
										<div className="label">shield-check</div>
									</div>
									<div className="col icon">
										<i className="bi bi-shield-exclamation"></i>
										<div className="label">shield-exclamation</div>
									</div>
									<div className="col icon">
										<i className="bi bi-shield-fill-check"></i>
										<div className="label">shield-fill-check</div>
									</div>
									<div className="col icon">
										<i className="bi bi-shield-fill-exclamation"></i>
										<div className="label">shield-fill-exclamation</div>
									</div>
									<div className="col icon">
										<i className="bi bi-shield-fill-minus"></i>
										<div className="label">shield-fill-minus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-shield-fill-plus"></i>
										<div className="label">shield-fill-plus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-shield-fill-x"></i>
										<div className="label">shield-fill-x</div>
									</div>
									<div className="col icon">
										<i className="bi bi-shield-fill"></i>
										<div className="label">shield-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-shield-lock-fill"></i>
										<div className="label">shield-lock-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-shield-lock"></i>
										<div className="label">shield-lock</div>
									</div>
									<div className="col icon">
										<i className="bi bi-shield-minus"></i>
										<div className="label">shield-minus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-shield-plus"></i>
										<div className="label">shield-plus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-shield-shaded"></i>
										<div className="label">shield-shaded</div>
									</div>
									<div className="col icon">
										<i className="bi bi-shield-slash-fill"></i>
										<div className="label">shield-slash-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-shield-slash"></i>
										<div className="label">shield-slash</div>
									</div>
									<div className="col icon">
										<i className="bi bi-shield-x"></i>
										<div className="label">shield-x</div>
									</div>
									<div className="col icon">
										<i className="bi bi-shield"></i>
										<div className="label">shield</div>
									</div>
									<div className="col icon">
										<i className="bi bi-shift-fill"></i>
										<div className="label">shift-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-shift"></i>
										<div className="label">shift</div>
									</div>
									<div className="col icon">
										<i className="bi bi-shop-window"></i>
										<div className="label">shop-window</div>
									</div>
									<div className="col icon">
										<i className="bi bi-shop"></i>
										<div className="label">shop</div>
									</div>
									<div className="col icon">
										<i className="bi bi-shuffle"></i>
										<div className="label">shuffle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-signpost-2-fill"></i>
										<div className="label">signpost-2-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-signpost-2"></i>
										<div className="label">signpost-2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-signpost-fill"></i>
										<div className="label">signpost-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-signpost-split-fill"></i>
										<div className="label">signpost-split-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-signpost-split"></i>
										<div className="label">signpost-split</div>
									</div>
									<div className="col icon">
										<i className="bi bi-signpost"></i>
										<div className="label">signpost</div>
									</div>
									<div className="col icon">
										<i className="bi bi-sim-fill"></i>
										<div className="label">sim-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-sim"></i>
										<div className="label">sim</div>
									</div>
									<div className="col icon">
										<i className="bi bi-skip-backward-btn-fill"></i>
										<div className="label">skip-backward-btn-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-skip-backward-btn"></i>
										<div className="label">skip-backward-btn</div>
									</div>
									<div className="col icon">
										<i className="bi bi-skip-backward-circle-fill"></i>
										<div className="label">skip-backward-circle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-skip-backward-circle"></i>
										<div className="label">skip-backward-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-skip-backward-fill"></i>
										<div className="label">skip-backward-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-skip-backward"></i>
										<div className="label">skip-backward</div>
									</div>
									<div className="col icon">
										<i className="bi bi-skip-end-btn-fill"></i>
										<div className="label">skip-end-btn-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-skip-end-btn"></i>
										<div className="label">skip-end-btn</div>
									</div>
									<div className="col icon">
										<i className="bi bi-skip-end-circle-fill"></i>
										<div className="label">skip-end-circle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-skip-end-circle"></i>
										<div className="label">skip-end-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-skip-end-fill"></i>
										<div className="label">skip-end-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-skip-end"></i>
										<div className="label">skip-end</div>
									</div>
									<div className="col icon">
										<i className="bi bi-skip-forward-btn-fill"></i>
										<div className="label">skip-forward-btn-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-skip-forward-btn"></i>
										<div className="label">skip-forward-btn</div>
									</div>
									<div className="col icon">
										<i className="bi bi-skip-forward-circle-fill"></i>
										<div className="label">skip-forward-circle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-skip-forward-circle"></i>
										<div className="label">skip-forward-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-skip-forward-fill"></i>
										<div className="label">skip-forward-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-skip-forward"></i>
										<div className="label">skip-forward</div>
									</div>
									<div className="col icon">
										<i className="bi bi-skip-start-btn-fill"></i>
										<div className="label">skip-start-btn-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-skip-start-btn"></i>
										<div className="label">skip-start-btn</div>
									</div>
									<div className="col icon">
										<i className="bi bi-skip-start-circle-fill"></i>
										<div className="label">skip-start-circle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-skip-start-circle"></i>
										<div className="label">skip-start-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-skip-start-fill"></i>
										<div className="label">skip-start-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-skip-start"></i>
										<div className="label">skip-start</div>
									</div>
									<div className="col icon">
										<i className="bi bi-skype"></i>
										<div className="label">skype</div>
									</div>
									<div className="col icon">
										<i className="bi bi-slack"></i>
										<div className="label">slack</div>
									</div>
									<div className="col icon">
										<i className="bi bi-slash-circle-fill"></i>
										<div className="label">slash-circle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-slash-circle"></i>
										<div className="label">slash-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-slash-lg"></i>
										<div className="label">slash-lg</div>
									</div>
									<div className="col icon">
										<i className="bi bi-slash-square-fill"></i>
										<div className="label">slash-square-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-slash-square"></i>
										<div className="label">slash-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-slash"></i>
										<div className="label">slash</div>
									</div>
									<div className="col icon">
										<i className="bi bi-sliders"></i>
										<div className="label">sliders</div>
									</div>
									<div className="col icon">
										<i className="bi bi-smartwatch"></i>
										<div className="label">smartwatch</div>
									</div>
									<div className="col icon">
										<i className="bi bi-snow"></i>
										<div className="label">snow</div>
									</div>
									<div className="col icon">
										<i className="bi bi-snow2"></i>
										<div className="label">snow2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-snow3"></i>
										<div className="label">snow3</div>
									</div>
									<div className="col icon">
										<i className="bi bi-sort-alpha-down-alt"></i>
										<div className="label">sort-alpha-down-alt</div>
									</div>
									<div className="col icon">
										<i className="bi bi-sort-alpha-down"></i>
										<div className="label">sort-alpha-down</div>
									</div>
									<div className="col icon">
										<i className="bi bi-sort-alpha-up-alt"></i>
										<div className="label">sort-alpha-up-alt</div>
									</div>
									<div className="col icon">
										<i className="bi bi-sort-alpha-up"></i>
										<div className="label">sort-alpha-up</div>
									</div>
									<div className="col icon">
										<i className="bi bi-sort-down-alt"></i>
										<div className="label">sort-down-alt</div>
									</div>
									<div className="col icon">
										<i className="bi bi-sort-down"></i>
										<div className="label">sort-down</div>
									</div>
									<div className="col icon">
										<i className="bi bi-sort-numeric-down-alt"></i>
										<div className="label">sort-numeric-down-alt</div>
									</div>
									<div className="col icon">
										<i className="bi bi-sort-numeric-down"></i>
										<div className="label">sort-numeric-down</div>
									</div>
									<div className="col icon">
										<i className="bi bi-sort-numeric-up-alt"></i>
										<div className="label">sort-numeric-up-alt</div>
									</div>
									<div className="col icon">
										<i className="bi bi-sort-numeric-up"></i>
										<div className="label">sort-numeric-up</div>
									</div>
									<div className="col icon">
										<i className="bi bi-sort-up-alt"></i>
										<div className="label">sort-up-alt</div>
									</div>
									<div className="col icon">
										<i className="bi bi-sort-up"></i>
										<div className="label">sort-up</div>
									</div>
									<div className="col icon">
										<i className="bi bi-soundwave"></i>
										<div className="label">soundwave</div>
									</div>
									<div className="col icon">
										<i className="bi bi-speaker-fill"></i>
										<div className="label">speaker-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-speaker"></i>
										<div className="label">speaker</div>
									</div>
									<div className="col icon">
										<i className="bi bi-speedometer"></i>
										<div className="label">speedometer</div>
									</div>
									<div className="col icon">
										<i className="bi bi-speedometer2"></i>
										<div className="label">speedometer2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-spellcheck"></i>
										<div className="label">spellcheck</div>
									</div>
									<div className="col icon">
										<i className="bi bi-square-fill"></i>
										<div className="label">square-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-square-half"></i>
										<div className="label">square-half</div>
									</div>
									<div className="col icon">
										<i className="bi bi-square"></i>
										<div className="label">square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-stack"></i>
										<div className="label">stack</div>
									</div>
									<div className="col icon">
										<i className="bi bi-star-fill"></i>
										<div className="label">star-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-star-half"></i>
										<div className="label">star-half</div>
									</div>
									<div className="col icon">
										<i className="bi bi-star"></i>
										<div className="label">star</div>
									</div>
									<div className="col icon">
										<i className="bi bi-stars"></i>
										<div className="label">stars</div>
									</div>
									<div className="col icon">
										<i className="bi bi-stickies-fill"></i>
										<div className="label">stickies-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-stickies"></i>
										<div className="label">stickies</div>
									</div>
									<div className="col icon">
										<i className="bi bi-sticky-fill"></i>
										<div className="label">sticky-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-sticky"></i>
										<div className="label">sticky</div>
									</div>
									<div className="col icon">
										<i className="bi bi-stop-btn-fill"></i>
										<div className="label">stop-btn-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-stop-btn"></i>
										<div className="label">stop-btn</div>
									</div>
									<div className="col icon">
										<i className="bi bi-stop-circle-fill"></i>
										<div className="label">stop-circle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-stop-circle"></i>
										<div className="label">stop-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-stop-fill"></i>
										<div className="label">stop-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-stop"></i>
										<div className="label">stop</div>
									</div>
									<div className="col icon">
										<i className="bi bi-stoplights-fill"></i>
										<div className="label">stoplights-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-stoplights"></i>
										<div className="label">stoplights</div>
									</div>
									<div className="col icon">
										<i className="bi bi-stopwatch-fill"></i>
										<div className="label">stopwatch-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-stopwatch"></i>
										<div className="label">stopwatch</div>
									</div>
									<div className="col icon">
										<i className="bi bi-subtract"></i>
										<div className="label">subtract</div>
									</div>
									<div className="col icon">
										<i className="bi bi-suit-club-fill"></i>
										<div className="label">suit-club-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-suit-club"></i>
										<div className="label">suit-club</div>
									</div>
									<div className="col icon">
										<i className="bi bi-suit-diamond-fill"></i>
										<div className="label">suit-diamond-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-suit-diamond"></i>
										<div className="label">suit-diamond</div>
									</div>
									<div className="col icon">
										<i className="bi bi-suit-heart-fill"></i>
										<div className="label">suit-heart-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-suit-heart"></i>
										<div className="label">suit-heart</div>
									</div>
									<div className="col icon">
										<i className="bi bi-suit-spade-fill"></i>
										<div className="label">suit-spade-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-suit-spade"></i>
										<div className="label">suit-spade</div>
									</div>
									<div className="col icon">
										<i className="bi bi-sun-fill"></i>
										<div className="label">sun-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-sun"></i>
										<div className="label">sun</div>
									</div>
									<div className="col icon">
										<i className="bi bi-sunglasses"></i>
										<div className="label">sunglasses</div>
									</div>
									<div className="col icon">
										<i className="bi bi-sunrise-fill"></i>
										<div className="label">sunrise-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-sunrise"></i>
										<div className="label">sunrise</div>
									</div>
									<div className="col icon">
										<i className="bi bi-sunset-fill"></i>
										<div className="label">sunset-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-sunset"></i>
										<div className="label">sunset</div>
									</div>
									<div className="col icon">
										<i className="bi bi-symmetry-horizontal"></i>
										<div className="label">symmetry-horizontal</div>
									</div>
									<div className="col icon">
										<i className="bi bi-symmetry-vertical"></i>
										<div className="label">symmetry-vertical</div>
									</div>
									<div className="col icon">
										<i className="bi bi-table"></i>
										<div className="label">table</div>
									</div>
									<div className="col icon">
										<i className="bi bi-tablet-fill"></i>
										<div className="label">tablet-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-tablet-landscape-fill"></i>
										<div className="label">tablet-landscape-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-tablet-landscape"></i>
										<div className="label">tablet-landscape</div>
									</div>
									<div className="col icon">
										<i className="bi bi-tablet"></i>
										<div className="label">tablet</div>
									</div>
									<div className="col icon">
										<i className="bi bi-tag-fill"></i>
										<div className="label">tag-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-tag"></i>
										<div className="label">tag</div>
									</div>
									<div className="col icon">
										<i className="bi bi-tags-fill"></i>
										<div className="label">tags-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-tags"></i>
										<div className="label">tags</div>
									</div>
									<div className="col icon">
										<i className="bi bi-telegram"></i>
										<div className="label">telegram</div>
									</div>
									<div className="col icon">
										<i className="bi bi-telephone-fill"></i>
										<div className="label">telephone-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-telephone-forward-fill"></i>
										<div className="label">telephone-forward-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-telephone-forward"></i>
										<div className="label">telephone-forward</div>
									</div>
									<div className="col icon">
										<i className="bi bi-telephone-inbound-fill"></i>
										<div className="label">telephone-inbound-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-telephone-inbound"></i>
										<div className="label">telephone-inbound</div>
									</div>
									<div className="col icon">
										<i className="bi bi-telephone-minus-fill"></i>
										<div className="label">telephone-minus-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-telephone-minus"></i>
										<div className="label">telephone-minus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-telephone-outbound-fill"></i>
										<div className="label">telephone-outbound-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-telephone-outbound"></i>
										<div className="label">telephone-outbound</div>
									</div>
									<div className="col icon">
										<i className="bi bi-telephone-plus-fill"></i>
										<div className="label">telephone-plus-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-telephone-plus"></i>
										<div className="label">telephone-plus</div>
									</div>
									<div className="col icon">
										<i className="bi bi-telephone-x-fill"></i>
										<div className="label">telephone-x-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-telephone-x"></i>
										<div className="label">telephone-x</div>
									</div>
									<div className="col icon">
										<i className="bi bi-telephone"></i>
										<div className="label">telephone</div>
									</div>
									<div className="col icon">
										<i className="bi bi-terminal-fill"></i>
										<div className="label">terminal-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-terminal"></i>
										<div className="label">terminal</div>
									</div>
									<div className="col icon">
										<i className="bi bi-text-center"></i>
										<div className="label">text-center</div>
									</div>
									<div className="col icon">
										<i className="bi bi-text-indent-left"></i>
										<div className="label">text-indent-left</div>
									</div>
									<div className="col icon">
										<i className="bi bi-text-indent-right"></i>
										<div className="label">text-indent-right</div>
									</div>
									<div className="col icon">
										<i className="bi bi-text-left"></i>
										<div className="label">text-left</div>
									</div>
									<div className="col icon">
										<i className="bi bi-text-paragraph"></i>
										<div className="label">text-paragraph</div>
									</div>
									<div className="col icon">
										<i className="bi bi-text-right"></i>
										<div className="label">text-right</div>
									</div>
									<div className="col icon">
										<i className="bi bi-textarea-resize"></i>
										<div className="label">textarea-resize</div>
									</div>
									<div className="col icon">
										<i className="bi bi-textarea-t"></i>
										<div className="label">textarea-t</div>
									</div>
									<div className="col icon">
										<i className="bi bi-textarea"></i>
										<div className="label">textarea</div>
									</div>
									<div className="col icon">
										<i className="bi bi-thermometer-half"></i>
										<div className="label">thermometer-half</div>
									</div>
									<div className="col icon">
										<i className="bi bi-thermometer-high"></i>
										<div className="label">thermometer-high</div>
									</div>
									<div className="col icon">
										<i className="bi bi-thermometer-low"></i>
										<div className="label">thermometer-low</div>
									</div>
									<div className="col icon">
										<i className="bi bi-thermometer-snow"></i>
										<div className="label">thermometer-snow</div>
									</div>
									<div className="col icon">
										<i className="bi bi-thermometer-sun"></i>
										<div className="label">thermometer-sun</div>
									</div>
									<div className="col icon">
										<i className="bi bi-thermometer"></i>
										<div className="label">thermometer</div>
									</div>
									<div className="col icon">
										<i className="bi bi-three-dots-vertical"></i>
										<div className="label">three-dots-vertical</div>
									</div>
									<div className="col icon">
										<i className="bi bi-three-dots"></i>
										<div className="label">three-dots</div>
									</div>
									<div className="col icon">
										<i className="bi bi-toggle-off"></i>
										<div className="label">toggle-off</div>
									</div>
									<div className="col icon">
										<i className="bi bi-toggle-on"></i>
										<div className="label">toggle-on</div>
									</div>
									<div className="col icon">
										<i className="bi bi-toggle2-off"></i>
										<div className="label">toggle2-off</div>
									</div>
									<div className="col icon">
										<i className="bi bi-toggle2-on"></i>
										<div className="label">toggle2-on</div>
									</div>
									<div className="col icon">
										<i className="bi bi-toggles"></i>
										<div className="label">toggles</div>
									</div>
									<div className="col icon">
										<i className="bi bi-toggles2"></i>
										<div className="label">toggles2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-tools"></i>
										<div className="label">tools</div>
									</div>
									<div className="col icon">
										<i className="bi bi-tornado"></i>
										<div className="label">tornado</div>
									</div>
									<div className="col icon">
										<i className="bi bi-translate"></i>
										<div className="label">translate</div>
									</div>
									<div className="col icon">
										<i className="bi bi-trash-fill"></i>
										<div className="label">trash-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-trash"></i>
										<div className="label">trash</div>
									</div>
									<div className="col icon">
										<i className="bi bi-trash2-fill"></i>
										<div className="label">trash2-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-trash2"></i>
										<div className="label">trash2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-tree-fill"></i>
										<div className="label">tree-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-tree"></i>
										<div className="label">tree</div>
									</div>
									<div className="col icon">
										<i className="bi bi-triangle-fill"></i>
										<div className="label">triangle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-triangle-half"></i>
										<div className="label">triangle-half</div>
									</div>
									<div className="col icon">
										<i className="bi bi-triangle"></i>
										<div className="label">triangle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-trophy-fill"></i>
										<div className="label">trophy-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-trophy"></i>
										<div className="label">trophy</div>
									</div>
									<div className="col icon">
										<i className="bi bi-tropical-storm"></i>
										<div className="label">tropical-storm</div>
									</div>
									<div className="col icon">
										<i className="bi bi-truck-flatbed"></i>
										<div className="label">truck-flatbed</div>
									</div>
									<div className="col icon">
										<i className="bi bi-truck"></i>
										<div className="label">truck</div>
									</div>
									<div className="col icon">
										<i className="bi bi-tsunami"></i>
										<div className="label">tsunami</div>
									</div>
									<div className="col icon">
										<i className="bi bi-tv-fill"></i>
										<div className="label">tv-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-tv"></i>
										<div className="label">tv</div>
									</div>
									<div className="col icon">
										<i className="bi bi-twitch"></i>
										<div className="label">twitch</div>
									</div>
									<div className="col icon">
										<i className="bi bi-twitter"></i>
										<div className="label">twitter</div>
									</div>
									<div className="col icon">
										<i className="bi bi-type-bold"></i>
										<div className="label">type-bold</div>
									</div>
									<div className="col icon">
										<i className="bi bi-type-h1"></i>
										<div className="label">type-h1</div>
									</div>
									<div className="col icon">
										<i className="bi bi-type-h2"></i>
										<div className="label">type-h2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-type-h3"></i>
										<div className="label">type-h3</div>
									</div>
									<div className="col icon">
										<i className="bi bi-type-italic"></i>
										<div className="label">type-italic</div>
									</div>
									<div className="col icon">
										<i className="bi bi-type-strikethrough"></i>
										<div className="label">type-strikethrough</div>
									</div>
									<div className="col icon">
										<i className="bi bi-type-underline"></i>
										<div className="label">type-underline</div>
									</div>
									<div className="col icon">
										<i className="bi bi-type"></i>
										<div className="label">type</div>
									</div>
									<div className="col icon">
										<i className="bi bi-ui-checks-grid"></i>
										<div className="label">ui-checks-grid</div>
									</div>
									<div className="col icon">
										<i className="bi bi-ui-checks"></i>
										<div className="label">ui-checks</div>
									</div>
									<div className="col icon">
										<i className="bi bi-ui-radios-grid"></i>
										<div className="label">ui-radios-grid</div>
									</div>
									<div className="col icon">
										<i className="bi bi-ui-radios"></i>
										<div className="label">ui-radios</div>
									</div>
									<div className="col icon">
										<i className="bi bi-umbrella-fill"></i>
										<div className="label">umbrella-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-umbrella"></i>
										<div className="label">umbrella</div>
									</div>
									<div className="col icon">
										<i className="bi bi-union"></i>
										<div className="label">union</div>
									</div>
									<div className="col icon">
										<i className="bi bi-unlock-fill"></i>
										<div className="label">unlock-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-unlock"></i>
										<div className="label">unlock</div>
									</div>
									<div className="col icon">
										<i className="bi bi-upc-scan"></i>
										<div className="label">upc-scan</div>
									</div>
									<div className="col icon">
										<i className="bi bi-upc"></i>
										<div className="label">upc</div>
									</div>
									<div className="col icon">
										<i className="bi bi-upload"></i>
										<div className="label">upload</div>
									</div>
									<div className="col icon">
										<i className="bi bi-vector-pen"></i>
										<div className="label">vector-pen</div>
									</div>
									<div className="col icon">
										<i className="bi bi-view-list"></i>
										<div className="label">view-list</div>
									</div>
									<div className="col icon">
										<i className="bi bi-view-stacked"></i>
										<div className="label">view-stacked</div>
									</div>
									<div className="col icon">
										<i className="bi bi-vinyl-fill"></i>
										<div className="label">vinyl-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-vinyl"></i>
										<div className="label">vinyl</div>
									</div>
									<div className="col icon">
										<i className="bi bi-voicemail"></i>
										<div className="label">voicemail</div>
									</div>
									<div className="col icon">
										<i className="bi bi-volume-down-fill"></i>
										<div className="label">volume-down-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-volume-down"></i>
										<div className="label">volume-down</div>
									</div>
									<div className="col icon">
										<i className="bi bi-volume-mute-fill"></i>
										<div className="label">volume-mute-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-volume-mute"></i>
										<div className="label">volume-mute</div>
									</div>
									<div className="col icon">
										<i className="bi bi-volume-off-fill"></i>
										<div className="label">volume-off-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-volume-off"></i>
										<div className="label">volume-off</div>
									</div>
									<div className="col icon">
										<i className="bi bi-volume-up-fill"></i>
										<div className="label">volume-up-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-volume-up"></i>
										<div className="label">volume-up</div>
									</div>
									<div className="col icon">
										<i className="bi bi-vr"></i>
										<div className="label">vr</div>
									</div>
									<div className="col icon">
										<i className="bi bi-wallet-fill"></i>
										<div className="label">wallet-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-wallet"></i>
										<div className="label">wallet</div>
									</div>
									<div className="col icon">
										<i className="bi bi-wallet2"></i>
										<div className="label">wallet2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-watch"></i>
										<div className="label">watch</div>
									</div>
									<div className="col icon">
										<i className="bi bi-water"></i>
										<div className="label">water</div>
									</div>
									<div className="col icon">
										<i className="bi bi-whatsapp"></i>
										<div className="label">whatsapp</div>
									</div>
									<div className="col icon">
										<i className="bi bi-wifi-1"></i>
										<div className="label">wifi-1</div>
									</div>
									<div className="col icon">
										<i className="bi bi-wifi-2"></i>
										<div className="label">wifi-2</div>
									</div>
									<div className="col icon">
										<i className="bi bi-wifi-off"></i>
										<div className="label">wifi-off</div>
									</div>
									<div className="col icon">
										<i className="bi bi-wifi"></i>
										<div className="label">wifi</div>
									</div>
									<div className="col icon">
										<i className="bi bi-wind"></i>
										<div className="label">wind</div>
									</div>
									<div className="col icon">
										<i className="bi bi-window-dock"></i>
										<div className="label">window-dock</div>
									</div>
									<div className="col icon">
										<i className="bi bi-window-sidebar"></i>
										<div className="label">window-sidebar</div>
									</div>
									<div className="col icon">
										<i className="bi bi-window"></i>
										<div className="label">window</div>
									</div>
									<div className="col icon">
										<i className="bi bi-wrench"></i>
										<div className="label">wrench</div>
									</div>
									<div className="col icon">
										<i className="bi bi-x-circle-fill"></i>
										<div className="label">x-circle-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-x-circle"></i>
										<div className="label">x-circle</div>
									</div>
									<div className="col icon">
										<i className="bi bi-x-diamond-fill"></i>
										<div className="label">x-diamond-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-x-diamond"></i>
										<div className="label">x-diamond</div>
									</div>
									<div className="col icon">
										<i className="bi bi-x-lg"></i>
										<div className="label">x-lg</div>
									</div>
									<div className="col icon">
										<i className="bi bi-x-octagon-fill"></i>
										<div className="label">x-octagon-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-x-octagon"></i>
										<div className="label">x-octagon</div>
									</div>
									<div className="col icon">
										<i className="bi bi-x-square-fill"></i>
										<div className="label">x-square-fill</div>
									</div>
									<div className="col icon">
										<i className="bi bi-x-square"></i>
										<div className="label">x-square</div>
									</div>
									<div className="col icon">
										<i className="bi bi-x"></i>
										<div className="label">x</div>
									</div>
									<div className="col icon">
										<i className="bi bi-youtube"></i>
										<div className="label">youtube</div>
									</div>
									<div className="col icon">
										<i className="bi bi-zoom-in"></i>
										<div className="label">zoom-in</div>
									</div>
									<div className="col icon">
										<i className="bi bi-zoom-out"></i>
										<div className="label">zoom-out</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default BootstrapIcon